import React, { useEffect, useMemo, useState } from "react";
import CentralizedTable from "../components/CentralizedTable";
import ManagerLeaveWfhOverview from '../components/ManagerLeaveWfhOverview';
import { useSelector } from "react-redux";
import { selectEmployees } from "src/stores/employeeSlice";
import { selectUser } from "src/stores/userSlice";
import { notify } from "../utils/ToastUtils";
import "../css/LeaveTabSA.css";
import "../css/commonStyles.css";
import ApiClient from '../ApiClient';
import ms from "ms";
import moment from "moment";
import { FiUpload, FiInfo, FiUploadCloud, FiDownload, FiX } from "react-icons/fi";
import { CheckCircle2, XCircle, Trash2, List, Edit3, History, Activity, Edit, ClipboardList, CalendarCheck, X, Download, Upload, CloudUpload, AlertTriangle, FastForward, AlertCircle, Search, MoreVertical, CalendarDays, Clock3, } from "lucide-react";
import * as XLSX from "xlsx";
import {
  DataGrid,
  GridToolbar,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid";

import Tooltip from "@mui/material/Tooltip";
import TailwindModal from "../components/TailwindModal";
import LoaderIcon from "../components/LoaderIcon";
import { FaArrowRightLong } from "react-icons/fa6";
import { useRef } from "react";
import { formatValue, normalizeTrimAndLowercase } from "src/Utils";
import { Box, Button, IconButton, Modal as MuiModal, TextField, Select, Autocomplete, MenuItem, FormControl, InputLabel, Chip } from "@mui/material";
import ActionConfirmModal from "../components/ActionConfirmModal";
import AcceptAllLeavesModal from "../components/AcceptAllLeavesModal";
import UserAvatar from "../components/UserAvatar";
import { AppContext } from "src/stores/ContextProvider";
import { useContext } from "react";
import { leaveOptions } from "../utils/constants";
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 3,
    borderRadius:"8px"
  };
const leaveBalanceHistoryColumns = [
  {
    headerName: "Updated At",
    field: "updated_at",
    width: 190,
  },
  {
    headerName: "Updated By",
    field: "updated_by",
    width: 130,
  },
  {
    headerName: "Emp Id",
    field: "emp_id",
    width: 100,
  },
  {
    headerName: "Name",
    field: "emp_name",
    // flex: 1,
    width: 150,
  },
  {
    headerName: "Prev Current",
    field: "prev_current",
    width: 110,
    type: "number",
    valueFormatter: (params) => formatValue(params?.value),
  },
  {
    headerName: "Prev Last",
    field: "prev_last",
    width: 110,
    type: "number",
    valueFormatter: (params) => formatValue(params?.value),
  },
  {
    headerName: "Prev Total",
    field: "prev_total",
    width: 110,
    type: "number",
    valueFormatter: (params) => formatValue(params?.value),
  },
  {
    headerName: "New Current",
    field: "new_current",
    width: 110,
    type: "number",
    valueFormatter: (params) => formatValue(params?.value),
  },
  {
    headerName: "New Last",
    field: "new_last",
    width: 110,
    type: "number",
    valueFormatter: (params) => formatValue(params?.value),
  },
  {
    headerName: "New Total",
    field: "new_total",
    width: 110,
    type: "number",
    valueFormatter: (params) => formatValue(params?.value),
  },
];
function LeaveTabSA({ hideExtraTabs = false }) {
  const employees = useSelector(selectEmployees);
  const user = useSelector(selectUser);
  const [leaves, setLeaves] = useState([]);
  const [leavesBalance, setLeavesBalance] = useState([]);
  const [newLeaves, setNewLeaves] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnsBalance, setColumnsBalance] = useState([]);
  const [leavesBalanceAsOn, setLeavesBalanceAsOn] = useState([]);
  const [editedBalanceRows, setEditedBalanceRows] = useState({});
  const editedBalanceRowsRef = useRef({});
  const [errors, setErrors] = useState({ import: [], saveValidation: [] });
  const [showImportModal, setShowImportModal] = useState(false);
  const [modalStep, setModalStep] = useState(0); // 0: Upload, 1: Preview
  const [importPreviewData, setImportPreviewData] = useState([]);
  const [actionLoading, setActionLoading] = useState(null);
  const [minDate1, setMinDate1] = useState(null);
  const [minDate2, setMinDate2] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const { officeHolidays: officeholidays } = useContext(AppContext);
  const [disableLeave, setDisableLeave] = useState(false);
  const [allHolidays, setAllHolidays] = useState([]);

  useEffect(() => {
    const fetchAllHolidays = async () => {
      try {
        const { data } = await ApiClient.post(`${process.env.REACT_APP_BASE_URL}/leave/officeholiday`, {
            year: moment().year(),
        });
        setAllHolidays(data || []);
      } catch (error) {
        console.error("Failed to fetch all holidays", error);
      }
    };
    fetchAllHolidays();
  }, []);
  
  const [loading, setLoading] = useState({ isInitial: true, general: false, history: false, lop: false });
  // const gridApiRef = null;
  const [leaveBalanceHistory, setLeaveBalanceHistory] = useState([]);
  
  const [leaveBalanceTab, setLeaveBalanceTab] = useState("current");
  const [editingCell, setEditingCell] = useState(null);
  const [originalBalanceMap, setOriginalBalanceMap] = useState({});
  const [editBalanceModalOpen, setEditBalanceModalOpen] = useState(false);
  const [editBalanceData, setEditBalanceData] = useState(null);
  const [confirmModal, setConfirmModal] = useState({
      isOpen: false,
      actionType: null,
      rowData: null,
      title: '',
      message: '',
      loading: false
  });
    const activeEmployees = useMemo(() => {
      if (!employees) return [];
      const active = employees.filter(e => e.STATUS === "Active");
      const unique = [];
      const seen = new Set();
      for (const emp of active) {
        if (emp.EMP_CODE && !seen.has(emp.EMP_CODE)) {
          seen.add(emp.EMP_CODE);
          unique.push(emp);
        }
      }
      return unique;
    }, [employees]);
  const [isAcceptAllModalOpen, setIsAcceptAllModalOpen] = useState(false);
    const [initialFetchDone, setInitialFetchDone] = useState(false);
      const [lopData, setLopData] = useState([]);
  
const [lopColumns, setLopColumns] = useState([
  {
    headerName: "Emp ID",
    field: "EMP_ID",
    sortable: true,
    flex: 1,
    minWidth: 150
  },
  {
    headerName: "Employee Name",
    field: "EMP_NAME",
    sortable: true,
    flex: 1,
    minWidth: 150
  },
  {
    headerName: "LOP (Days)",
    field: "lop",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <Box sx={{ pl: 1, width: "100%" }}>
        {params.value != null && params.value !== "" ? Number(params.value) : ""}
      </Box>
    )
  }
]);
  const [balanceT, setBalanceT] = useState({
    empName: "",
    startDate: "",
    endDate: "",
  });
  const initialState = {
    empName1: "",
    startDate: "",
    endDate: "",
    noOfDays: "",
    leaveType: "",
  empName2: [],
  filterLeaveType: "All",
    startDt: moment().startOf('month').format("YYYY-MM-DD"),
    endDt: moment().format("YYYY-MM-DD"),
  };
  const [state, setState] = useState(initialState);
  const [applyLeaveError, setApplyLeaveError] = useState("");
  const [bottomTab, setBottomTab] = useState('records');


  const openConfirmModal = (actionType, rowData, title, message) => {
      setConfirmModal({
          isOpen: true,
          actionType,
          rowData,
          title,
          message,
          loading: false
      });
  };

  const closeConfirmModal = () => {
      setConfirmModal({
          isOpen: false,
          actionType: null,
          rowData: null,
          title: '',
          message: '',
          loading: false
      });
  };

  const handleConfirm = async () => {
      const { actionType, rowData } = confirmModal;
      setConfirmModal(prev => ({ ...prev, loading: true }));
      setActionLoading({ type: actionType, id: rowData?.REQUEST_ID });
      if (actionType === 'reject') {
          await rejectLeaveReq(rowData);
      } else if (actionType === 'delete') {
          await deleteLeaveReq(rowData);
      } else if (actionType === 'rejectDelete') {
          await deleteLeaveReject(rowData);
      } else if (actionType === 'acceptDelete') {
          await deleteLeaveAccept(rowData);
      }
      closeConfirmModal();
      setActionLoading(null);
  };

  const handleAcceptAllSelected = async (selectedRows) => {
      setActionLoading({ type: 'acceptAll', id: null });
      try {
          await acceptAllLeaveReqs(selectedRows);
      } finally {
          setIsAcceptAllModalOpen(false);
          setActionLoading(null);
      }
  };

  const openEditBalanceModal = (rowData) => {
    setEditBalanceData({ ...rowData });
    setEditBalanceModalOpen(true);
  };

  const handleEditBalanceChange = (e) => {
    const { name, value } = e.target;
    setEditBalanceData((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === 'current_year' || name === 'prev_year') {
        const curr = parseFloat(updated.current_year || 0) || 0;
        const prevYear = parseFloat(updated.prev_year || 0) || 0;
        updated.total = (curr + prevYear).toString();
      }
      return updated;
    });
  };

  const handleSaveEditBalance = async () => {
    setLoading(prev => ({ ...prev, general: true }));
    setErrors(prev => ({ ...prev, saveValidation: [] }));
    try {
      // Validate inputs
      const current = toNumericValue(editBalanceData.current_year);
      const previous = toNumericValue(editBalanceData.prev_year);
      const total = toNumericValue(editBalanceData.total);
      
      if (!doesTotalMatch(current, previous, total)) {
        const expectedTotal = roundToPrecision(current + previous);
        setErrors(prev => ({
          ...prev,
          saveValidation: [
            `Total is incorrect. It should be ${formatValue(expectedTotal)} based on Current (${formatValue(current)}) and Last (${formatValue(previous)}).`
          ]
        }));
        setLoading(prev => ({ ...prev, general: false }));
        return;
      }

      const payloadRecord = {
        ...editBalanceData,
        current_year: current,
        prev_year: previous,
        total: total,
      };

      await ApiClient.put(
        `${process.env.REACT_APP_BASE_URL}/admin/updateLeaveBalanceAsOn`,
        { records: [payloadRecord], updated_by: user.name },
        { headers: { skipLoader: true } }
      );
      notify.success("Leave balance updated successfully");
      setEditBalanceModalOpen(false);
      await getLeaveBalanceAsOn();
      await fetchLeaveBalanceHistory(balanceT.empName);
    } catch (error) {
      console.log(error);
      let errmsg = error?.response?.data?.message || "Something went wrong. Please try again later";
      notify.error(errmsg);
    }
    setLoading(prev => ({ ...prev, general: false }));
  };

  const getCycleBounds = () => {
    const date = new Date();
    let cycleStart, cycleEnd;
    if (date.getDate() >= 20) {
      cycleStart = new Date(date.getFullYear(), date.getMonth(), 20);
      cycleEnd = new Date(date.getFullYear(), date.getMonth() + 1, 19);
    } else {
      cycleStart = new Date(date.getFullYear(), date.getMonth() - 1, 20);
      cycleEnd = new Date(date.getFullYear(), date.getMonth(), 19);
    }
    return {
      start: moment(cycleStart).format('YYYY-MM-DD'),
      end: moment(cycleEnd).format('YYYY-MM-DD')
    };
  };
  const cycleBounds = getCycleBounds();

  console.log(user);

  function handleChange(evt) {
    setApplyLeaveError("")
    const data = evt.target.value;
    const name = evt.target.name;
    if (name === "noOfDays") {
      let { value, max } = evt.target;
      if (value !== "") {
        let numVal = Number(value);
        if (numVal > Number(max)) {
          value = max;
        } else if (numVal < 0) {
          value = 0;
        }
      }
      setState(prev => ({
        ...prev,
        [name]: value,
      }));
    } else {
      setState(prev => ({
        ...prev,
        [name]: data,
      }));
    }
  }

  function handleBalanceChange(evt) {
    const data = evt.target.value;
    setBalanceT({
      ...balanceT,
      [evt.target.name]: data,
    });
  }

  const getLopData = async () => {
    setLoading(prev => ({ ...prev, lop: true }));
    try {
      const bounds = getCycleBounds();
      const { data } = await ApiClient.get(
        `${process.env.REACT_APP_BASE_URL}/admin/getLopTracker`,
        {
          params: {
            startDt: bounds.start,
            endDt: bounds.end,
          },
        }
      );
      const resetDate = moment(bounds.end).add(1, 'days').format('DD-MMM-YYYY');
      const modifiedData = data.map((item) => ({
        ...item,
        id: item.EMP_CODE,
        lop: item.lop != null && item.lop !== "" ? Number(item.lop) : item.lop,
        resetDate: resetDate
      }));
      setLopData(modifiedData);
    } catch (error) {
      console.log(error);
      notify.error("Failed to fetch LOP data");
    }
    setLoading(prev => ({ ...prev, lop: false }));
  };

  useEffect(() => {
    if (user?.role !== "Manager") {
      getLopData();
    }
  }, [user]);

  const acceptLeaveReq = async (row) => {
    if (actionLoading) return;
    setActionLoading({ type: 'accept', id: row.REQUEST_ID });
    try {
      await ApiClient.get(
        `${process.env.REACT_APP_BASE_URL}/action/leavereqAccept/?id=${row.REQUEST_ID}`,
        { params: { name: user?.name } }
      );
      await fetchNewLeaves();
      notify.success("Leave accepted");
    } catch (error) {
      console.log(error);
      let errmsg = error?.response
        ? error?.response?.data?.message
          ? error?.response?.data?.message
          : `${error?.response?.status} - ${error?.response?.statusText}`
        : "Something went wrong. Please try again later";
      notify.error(errmsg);
    } finally {
      setActionLoading(null);
    }
  };

  const acceptAllLeaveReqs = async (selectedRows) => {
    if (!selectedRows || selectedRows.length === 0) return;
    try {
      for (const row of selectedRows) {
        await ApiClient.get(
          `${process.env.REACT_APP_BASE_URL}/action/leavereqAccept/?id=${row.REQUEST_ID}`,
          { params: { name: user?.name } }
        );
      }
      await fetchNewLeaves();
      notify.success("Selected pending leaves accepted successfully");
    } catch (error) {
      console.log(error);
      notify.error("Failed to accept some leave requests");
    }
  };

  const rejectLeaveReq = async (row) => {
    try {
      await ApiClient.get(
        `${process.env.REACT_APP_BASE_URL}/action/rejectLeave?id=${row.REQUEST_ID}`
      );
      await fetchNewLeaves();
      notify.success("Leave rejected");
    } catch (error) {
      console.log(error);
      let errmsg = error?.response
        ? error?.response?.data?.message
          ? error?.response?.data?.message
          : `${error?.response?.status} - ${error?.response?.statusText}`
        : "Something went wrong. Please try again later";
      notify.error(errmsg);
    }
  };

  const deleteLeaveReq = async (row) => {
    try {
      await ApiClient.delete(
        `${process.env.REACT_APP_BASE_URL}/leave/deleteLeave`,
        { data: { data: row } }
      );
      await fetchNewLeaves();
      notify.success("Leave deleted");
    } catch (error) {
      console.log(error);
      let errmsg = error?.response
        ? error?.response?.data?.message
          ? error?.response?.data?.message
          : `${error?.response?.status} - ${error?.response?.statusText}`
        : "Something went wrong. Please try again later";
      notify.error(errmsg);
    }
  };

  const deleteLeaveAccept = async (row) => {
    try {
      await ApiClient.delete(
        `${process.env.REACT_APP_BASE_URL}/leave/deleteLeave`,
        { data: { data: row } }
      );
      notify.success("Leave Deleted Successfully");
      await fetchNewLeaves();
    } catch (error) {
      notify.error("Something went wrong. Please try again later");
    }
  };

  const deleteLeaveReject = async (row) => {
    try {
      await ApiClient.put(
        `${process.env.REACT_APP_BASE_URL}/leave/rejectDeleteLeave`,
        { REQUEST_ID: row.REQUEST_ID, STATUS: "Reject" }
      );
      notify.success("Delete Request Rejected Successfully");
      await fetchNewLeaves();
    } catch (error) {
      notify.error("Something went wrong. Please try again later");
    }
  };

  const newLeaveCols = useMemo(() => [
        {
          headerName: "Employee",
          field: "EMP_NAME",
          sortable: true,
          width: 180,
          renderCell: (params) => {
              return (
              <div className="flex items-center">
                  <UserAvatar name={params.row.EMP_NAME} size={38} className="me-3" />
                  <div className="flex flex-col justify-center">
                      <h3 className="text-[14px] font-semibold m-0 leading-tight text-slate-800">{params.row.EMP_NAME}</h3>
                      <div className="flex items-center gap-2 mt-1">
                          <p className="text-[11px] font-medium text-slate-500 m-0 uppercase tracking-widest">{params.row.EMP_ID || 'N/A'}</p>
                      </div>
                  </div>
              </div>
          )},
        },
        {
          headerName: "Request",
          field: "LEAVE_REQUEST",
          sortable: true,
          width: 140,
          renderCell: (params) => {
            const isDeleteReq = !!params?.row?.REQUEST_TYPE;
            const text = isDeleteReq ? "Awaiting Delete" : "Pending Approval";
            const bgClass = isDeleteReq ? "bg-orange-50 text-orange-600" : "bg-blue-50 text-blue-600";
            const dotClass = isDeleteReq ? "bg-orange-500" : "bg-blue-500";
            return (
              <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold w-max ${bgClass}`}>
                <div className={`w-1.5 h-1.5 rounded-full ${dotClass}`}></div>
                {text}
              </div>
            );
          },
        },
        {
          headerName: "Leave Type",
          field: "LEAVE_TYPE",
          sortable: true,
          width: 150,
          renderCell: (params) => (
            <span className="text-slate-700">
              {params?.row?.LEAVE_TYPE}
            </span>
          ),
        },
        {
          headerName: "#Days",
          field: "NO_OF_DAYS",
          sortable: true,
          width: 60,
          renderCell: (params) => (
            <span className={!params?.row?.REQUEST_TYPE ? null : 'text-red'}>
              {params?.row?.NO_OF_DAYS}
            </span>
          ),
        },
        {
          headerName: "Start Date",
          field: "START_DATE",
          sortable: true,
          width: 100,
          renderCell: (params) => (
            <span className={!params?.row?.REQUEST_TYPE ? null : 'text-red'}>
              {moment(params.row?.START_DATE).format("DD-MMM-YY")}
            </span>
          ),
        },
        {
          headerName: "End Date",
          field: "END_DATE",
          sortable: true,
          width: 100,
          renderCell: (params) => (
            <span className={!params?.row?.REQUEST_TYPE ? null : 'text-red'}>
              {moment(params.row?.END_DATE).format("DD-MMM-YY")}
            </span>
          ),
        },
        {
          headerName: "Leave Reason",
          field: "LEAVE_REASON",
          width: 200,
          renderCell: (params) => (
          <Tooltip title={params.value || ""}>
            <div
              style={{
                width: 180, // slightly less than column width
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {params.value}
            </div>
          </Tooltip>
          ),
        },
        {
          headerName: "Action",
          field: "LEAVE_ACTION",
          sortable: false,
          width: 120,
          headerClassName: 'sticky-action-col',
          cellClassName: 'sticky-action-col',
          renderCell: (params) => {
            const isLoading = actionLoading !== null;
            const isAccepting = actionLoading?.type === 'accept' && actionLoading?.id === params.row.REQUEST_ID;
            const isRejecting = actionLoading?.type === 'reject' && actionLoading?.id === params.row.REQUEST_ID;
            const isDeleting = actionLoading?.type === 'delete' && actionLoading?.id === params.row.REQUEST_ID;
            const isRejectDeleting = actionLoading?.type === 'rejectDelete' && actionLoading?.id === params.row.REQUEST_ID;
            const isAcceptDeleting = actionLoading?.type === 'acceptDelete' && actionLoading?.id === params.row.REQUEST_ID;

            return !params?.row?.REQUEST_TYPE ? (
              <div className="flex items-center gap-3 ms-1">
                <Tooltip title="Accept">
                  <div
                    onClick={() => !isLoading && acceptLeaveReq(params.row)}
                    className={`w-7 h-7 flex items-center justify-center transition-colors rounded-md ${isLoading ? (isAccepting ? 'cursor-wait' : 'cursor-not-allowed opacity-50') : 'cursor-pointer hover:bg-green-50'}`}
                  >
                    {isAccepting ? <div className="w-4 h-4 border-2 border-green-600/30 border-t-green-600 rounded-full animate-spin" /> : <CheckCircle2 size={20} className="text-green-600" />}
                  </div>
                </Tooltip>
                <Tooltip title="Reject">
                  <div
                    onClick={() => {
                        if (isLoading) return;
                        const start = moment(params.row.START_DATE).format("DD-MMM-YYYY");
                        const end = moment(params.row.END_DATE).format("DD-MMM-YYYY");
                        openConfirmModal('reject', params.row, 'Reject Leave', `Are you sure you want to reject this leave request for ${params.row.EMP_NAME} (ID: ${params.row.EMP_ID}) from ${start} to ${end}?`);
                    }}
                    className={`w-7 h-7 flex items-center justify-center transition-colors rounded-md ${isLoading ? (isRejecting ? 'cursor-wait' : 'cursor-not-allowed opacity-50') : 'cursor-pointer hover:bg-red-50'}`}
                  >
                    {isRejecting ? <div className="w-4 h-4 border-2 border-red-600/30 border-t-red-600 rounded-full animate-spin" /> : <XCircle size={20} className="text-red-600" />}
                  </div>
                </Tooltip>
                <Tooltip title="Delete">
                  <div
                    onClick={() => {
                        if (isLoading) return;
                        const start = moment(params.row.START_DATE).format("DD-MMM-YYYY");
                        const end = moment(params.row.END_DATE).format("DD-MMM-YYYY");
                        openConfirmModal('delete', params.row, 'Delete Leave', `Are you sure you want to delete this leave request for ${params.row.EMP_NAME} (ID: ${params.row.EMP_ID}) from ${start} to ${end}?\nThis action cannot be undone.`);
                    }}
                    className={`w-7 h-7 flex items-center justify-center transition-colors rounded-md ${isLoading ? (isDeleting ? 'cursor-wait' : 'cursor-not-allowed opacity-50') : 'cursor-pointer hover:bg-slate-100'}`}
                  >
                    {isDeleting ? <div className="w-4 h-4 border-2 border-slate-600/30 border-t-slate-600 rounded-full animate-spin" /> : <Trash2 size={16} className="text-slate-600" />}
                  </div>
                </Tooltip>
              </div>
            ) : (
              <div className="flex items-center gap-3 w-full ms-1">
                <Tooltip title="Reject">
                  <div
                    onClick={() => {
                        if (isLoading) return;
                        const start = moment(params.row.START_DATE).format("DD-MMM-YYYY");
                        const end = moment(params.row.END_DATE).format("DD-MMM-YYYY");
                        openConfirmModal('rejectDelete', params.row, 'Reject Deletion', `Are you sure you want to reject the deletion of this leave request for ${params.row.EMP_NAME} (ID: ${params.row.EMP_ID}) from ${start} to ${end}?`);
                    }}
                    className={`w-7 h-7 flex items-center justify-center transition-colors rounded-md ${isLoading ? (isRejectDeleting ? 'cursor-wait' : 'cursor-not-allowed opacity-50') : 'cursor-pointer hover:bg-red-50'}`}
                  >
                    {isRejectDeleting ? <div className="w-4 h-4 border-2 border-red-600/30 border-t-red-600 rounded-full animate-spin" /> : <XCircle size={20} className="text-red-600" />}
                  </div>
                </Tooltip>
                <Tooltip title="Delete">
                  <div
                    onClick={() => {
                        if (isLoading) return;
                        const start = moment(params.row.START_DATE).format("DD-MMM-YYYY");
                        const end = moment(params.row.END_DATE).format("DD-MMM-YYYY");
                        openConfirmModal('acceptDelete', params.row, 'Approve Deletion', `Are you sure you want to approve the deletion of this leave request for ${params.row.EMP_NAME} (ID: ${params.row.EMP_ID}) from ${start} to ${end}?\nThis action cannot be undone.`);
                    }}
                    className={`w-7 h-7 flex items-center justify-center transition-colors rounded-md ${isLoading ? (isAcceptDeleting ? 'cursor-wait' : 'cursor-not-allowed opacity-50') : 'cursor-pointer hover:bg-slate-100'}`}
                  >
                    {isAcceptDeleting ? <div className="w-4 h-4 border-2 border-slate-600/30 border-t-slate-600 rounded-full animate-spin" /> : <Trash2 size={16} className="text-slate-600" />}
                  </div>
                </Tooltip>
              </div>
            );
          }
        }
  ], [actionLoading]);

  const fetchNewLeaves = async () => {
    setDisableLeave(true);
    try {
      const { data } = await ApiClient.get(
        `${process.env.REACT_APP_BASE_URL}/admin/newLeaveRequest`,
        { params: { mail: user?.mail } }
      );
      setNewLeaves(data);
    } catch (error) {
      console.log(error);
    } finally {
      setDisableLeave(false);
    }
  };

  const resetFilter = () => {
    setState({
      ...state,
      empName2: [],
      filterLeaveType: "All",
      startDt: moment().startOf('month').format("YYYY-MM-DD"),
      endDt: moment().format("YYYY-MM-DD"),
    });
    setLeaves([]);
  };

  const getLeavesByDate = async () => {
  setDisableLeave(true);
    let leaveTableCols = [
              {
                headerName: "Emp ID",
                field: "EMP_ID",
                sortable: true,
                width: 100,
              },
              {
                headerName: "Name",
                field: "EMP_NAME",
                sortable: true,
                width: 220,
              },
              {
      headerName: "Leave Type",
      field: "LEAVE_TYPE",
      sortable: true,
      width: 150,
      renderCell: (params) => {
        let bg = 'bg-slate-50 text-slate-600';
        const type = params.row.LEAVE_TYPE;
        if (type === 'Special Leave' || type === 'Personal Leave') bg = 'bg-blue-50 text-blue-600';
        else if (type === 'Emergency Leave') bg = 'bg-orange-50 text-orange-600';
        else if (type === 'Sick/Medical Leave') bg = 'bg-purple-50 text-purple-600';
        else if (type === 'Maternity Leave' || type === 'Paternity Leave') bg = 'bg-pink-50 text-pink-600';
        else if (type === 'Casual Leave') bg = 'bg-green-50 text-green-600';
        
        return (
          <span className={`px-3 py-1 rounded-full text-[11px] font-bold ${bg}`}>
            {type}
          </span>
        );
      }
    },
              {
                headerName: "#Days",
                field: "NO_OF_DAYS",
                sortable: true,
                width: 75,
              },
              {
                headerName: "Start Date",
                field: "START_DATE",
                sortable: true,
                width: 130,
                valueGetter: (params) => {
                  return moment(params.row?.START_DATE).format("DD-MMM-YYYY");
                },
              },
              {
                headerName: "End Date",
                field: "END_DATE",
                sortable: true,
                width: 130,
                valueGetter: (params) => {
                  return moment(params.row?.END_DATE).format("DD-MMM-YYYY");
                },
              },
              {
                headerName: "Leave Reason",
                field: "LEAVE_REASON",
                sortable: true,
                width: 200,
                  renderCell: (params) => (
  <Tooltip title={params.value || ""}>
    <div
      style={{
        width: 180, // slightly less than column width
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
      }}
    >
      {params.value}
    </div>
  </Tooltip>

  ),
              },
              {
      headerName: "Status",
      field: "LEAVE_STATUS",
      sortable: true,
      width: 130,
      valueGetter: (params) => {
        return params.row?.LEAVE_STATUS
          ? params.row?.LEAVE_STATUS
          : "Pending";
      },
      renderCell: (params) => {
        const s = params.row?.LEAVE_STATUS || "Pending";
        let bg = 'bg-yellow-50 text-yellow-600';
        let dot = 'bg-yellow-500';
        if (s === 'Accepted' || s === 'Approved') {
          bg = 'bg-green-50 text-green-600';
          dot = 'bg-green-500';
        } else if (s === 'Rejected' || s === 'Declined') {
          bg = 'bg-red-50 text-red-600';
          dot = 'bg-red-500';
        }
        return (
          <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold ${bg} w-max`}>
            <div className={`w-1.5 h-1.5 rounded-full ${dot}`}></div>
            {s}
          </div>
        );
      }
    },
            ];
    setColumns(leaveTableCols);
    try {
      if (state.startDt && state.endDt) {
        if (new Date(state.startDt) <= new Date(state.endDt)) {
          const { data } = await ApiClient.post(
            `${process.env.REACT_APP_BASE_URL}/admin/getLeaveRecords`,
            {
              code: state.empName2 && state.empName2.length > 0 ? state.empName2.map(e => e.EMP_CODE) : "",
              leaveType: state.filterLeaveType === "All" ? "" : state.filterLeaveType,
              startDt: state.startDt,
              endDt: state.endDt,
            }
          );
          if (data.length === 0) {
            // notify.error("No matching records found");
            setLeaves([]);
          } else {
            setColumns(leaveTableCols);
            setLeaves(data);
          }
          setDisableLeave(false);
        } else notify.error("Start Date should be less than End Date");
      } else {
        setDisableLeave(false);
        notify.error("Start Date and End Date fields are mandatory");
      }
    } catch (error) {
      console.log(error);
      setDisableLeave(false);
      let errmsg = error?.response
        ? error?.response?.data?.message
          ? error?.response?.data?.message
          : `${error?.response?.status} - ${error?.response?.statusText}`
        : "Something went wrong. Please try again later";
      notify.error(errmsg);
    }
  };

  const findNoOfDays = (sDate, eDate) => {
    var startDate = new Date(sDate);
    var endDate = new Date(eDate);
    if (startDate < new Date(balanceT.startDate)) {
      startDate = new Date(balanceT.startDate);
    }
    if (endDate > new Date(balanceT.endDate)) {
      endDate = new Date(balanceT.endDate);
    }
    endDate.setDate(endDate.getDate() + 1);
    const daysOfWeek = [];
    let i = 0;
    while (startDate < endDate) {
      if (startDate.getDay() !== 0 && startDate.getDay() !== 6) {
        if (!isInArray(moment(startDate).format("YYYY-MM-DD")))
          daysOfWeek.push(startDate.getDay());
      }
      startDate.setDate(startDate.getDate() + 1);
      i++;
    }
    return daysOfWeek.length;
  };

  const isInArray = (value, loc) => {
    if (!loc || !allHolidays?.length) return false;

    const holidaysForLoc = allHolidays
      .filter(
        (el) =>
          el.LOCATION === loc ||
          (loc !== "India" && el.LOCATION !== "India")
      )
      .map((el) => moment(el.DATE).format("YYYY-MM-DD"));

    return holidaysForLoc.includes(value);
  };

  const findNoOfDaysForLeave = (sDate, eDate, loc) => {
    let startDate = new Date(sDate);
    let endDate = new Date(eDate);
    startDate = new Date(Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate()));
    endDate = new Date(Date.UTC(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate()));
    endDate.setUTCDate(endDate.getUTCDate() + 1);
    let daysCount = 0;
    while (startDate < endDate) {
      const day = startDate.getUTCDay(); 
      if (day !== 0 && day !== 6) {
        if (!isInArray(moment.utc(startDate).format("YYYY-MM-DD"), loc)) {
          daysCount++;
        }
      }
      startDate.setUTCDate(startDate.getUTCDate() + 1);
    }
    return daysCount;
  };

  useEffect(() => {
    if (state.startDate && state.endDate) {
      if (new Date(state.startDate) <= new Date(state.endDate)) {
        
        const selectedEmp = employees?.find((emp) => emp.EMP_CODE === state.empName1);
        const loc = selectedEmp ? selectedEmp.EMP_COUNTRY : user?.country;

        let newDays = 0;
        if (state.startDate === state.endDate) {
          const day = new Date(state.startDate).getUTCDay(); 
          if (day === 0 || day === 6 || isInArray(moment.utc(state.startDate).format("YYYY-MM-DD"), loc)) {
            newDays = 0;
          } else {
            newDays = 1;
          }
        } else {
          newDays = findNoOfDaysForLeave(state.startDate, state.endDate, loc);
        }
        
        setState((prev) => {
          const finalDays = (state.startDate === state.endDate && prev.noOfDays === 0.5 && newDays !== 0) ? 0.5 : newDays;
          if (prev.noOfDays !== finalDays) {
            return { ...prev, noOfDays: finalDays };
          }
          return prev;
        });
      }
    }
  }, [state.startDate, state.endDate, state.empName1, allHolidays, employees, user]);

   const columnsBalanceAsOn = useMemo(()=> [
        {
          headerName: "Emp ID",
          field: "emp_id",
          sortable: true,
          width: 120,
          flex: 1,
        },
        {
          headerName: "Name",
          field: "emp_name",
          sortable: true,
          width: 220,
          flex: 1.5,
        },
        {
          headerName: "Current Year",
          field: "current_year",
          sortable: true,
          width: 150,
          flex: 1,
          type: "number",
          valueFormatter: (params) => {
            const value = params?.value;

            if (value == null || value === "") return "";

            // Check if it's a valid number
            const num = Number(value);

            // If NOT a number → return original value
            if (isNaN(num)) {
              return value;
            }

            // If number → format it
            return formatValue(num);
          }
        },
        {
          headerName: "Last Year",
          field: "prev_year",
          sortable: true,
          width: 150,
          flex: 1,
          type: "number",
            valueFormatter: (params) => {
            const value = params?.value;

            if (value == null || value === "") return "";

            // Check if it's a valid number
            const num = Number(value);

            // If NOT a number → return original value
            if (isNaN(num)) {
              return value;
            }

            // If number → format it
            return formatValue(num);
          }
        },
        {
          headerName: "Total",
          field: "total",
          sortable: true,
          width: 150,
          flex: 1,
          type: "number",
            valueFormatter: (params) => {
            const value = params?.value;

            if (value == null || value === "") return "";

            // Check if it's a valid number
            const num = Number(value);

            // If NOT a number → return original value
            if (isNaN(num)) {
              return value;
            }

            // If number → format it
            return formatValue(num);
          }
        },
        {
          headerName: "Action",
          field: "ACTION",
          sortable: false,
          width: 100,
          headerClassName: 'sticky-action-col',
          cellClassName: 'sticky-action-col',
          renderCell: (params) => (
            <div className="flex items-center justify-center w-full">
              <Tooltip title="Edit Leave Balance">
                <button
                  onClick={() => openEditBalanceModal(params.row)}
                  className="w-7 h-7 rounded border border-blue-100 text-blue-500 flex items-center justify-center hover:bg-blue-50 transition-colors bg-white shadow-sm"
                >
                  <Edit size={12} strokeWidth={2.5} />
                </button>
              </Tooltip>
            </div>
          ),
        }
      ],[leavesBalanceAsOn])
  const fileInputRef = useRef(null);

  const selectMenuProps = {
    PaperProps: {
      style: {
        maxHeight: 300,
        borderRadius: "12px",
        marginTop: "4px",
        boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
        border: "1px solid #e2e8f0",
      },
      sx: {
        "& .MuiMenuItem-root": {
          fontSize: "14px"
        }
      }
    },
    MenuListProps: {
      style: {
        padding: "8px"
      }
    }
  };

  const getLeaveBalanceAsOn = async () => {
    setDisableLeave(true);
      try {
        const { data } = await ApiClient.post(
          `${process.env.REACT_APP_BASE_URL}/admin/getLeaveBalanceAsOn`,
          {
            code: balanceT.empName,
          },
          { headers: { skipLoader: true } }
        );
      setLeavesBalanceAsOn(data);
      const map = {};
      data.forEach(row => {
        map[row.emp_code] = { ...row };
      });
      setOriginalBalanceMap(map);
      setErrors(prev => ({ ...prev, saveValidation: [] }));
      setEditedBalanceRows({});
      editedBalanceRowsRef.current = {};
      } catch (error) {
        console.log(error);
        let errmsg = error?.response
          ? error?.response?.data?.message
            ? error?.response?.data?.message
            : `${error?.response?.status} - ${error?.response?.statusText}`
          : "Something went wrong. Please try again later";
        notify.error(errmsg);
      } finally {
        setDisableLeave(false);
      }
    };

    const getTrimmedValue = (value) => {
      if (value === undefined || value === null) return "";
      return String(value).trim();
    };

    const getValue = (obj, key) => {
      const foundKey = Object.keys(obj).find(
        (k) => normalizeTrimAndLowercase(k) === normalizeTrimAndLowercase(key)
      );
      return foundKey ? obj[foundKey] : "";
    };
    const numericPattern = /^-?(?:\d+|\d*\.\d+)$/;

    const isNumericInputValue = (value) => {
      const trimmed = getTrimmedValue(value);
      if (!trimmed) return true;
      return numericPattern.test(trimmed);
    };

    const toNumericValue = (value) => {
      const trimmed = getTrimmedValue(value);
      if (!trimmed) return 0;
      const numberValue = Number(trimmed);
      return Number.isFinite(numberValue) ? numberValue : 0;
    };

    const roundToPrecision = (value, decimals = 1) => {
      if (!Number.isFinite(value)) return 0;
      const factor = 10 ** decimals;
      return Math.round(value * factor + Number.EPSILON) / factor;
    };

    const doesTotalMatch = (current, previous, total) => {
      if (
        !Number.isFinite(current) ||
        !Number.isFinite(previous) ||
        !Number.isFinite(total)
      )
        return false;
      const expectedTotal = roundToPrecision(current + previous);
      const roundedTotal = roundToPrecision(total);
      return Math.abs(expectedTotal - roundedTotal) < 0.05;
    };

    const balanceNumericFields = [
      { key: "current_year", label: "Current Year" },
      { key: "prev_year", label: "Last Year" },
      { key: "total", label: "Total" },
    ];
  

const LeaveBalanceToolbar = ({ onImportClick }) => (
  <GridToolbarContainer
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "6px 6px",
      borderBottom:"1px solid #e0e0e0",
      // flexWrap: "wrap",
      gap: "10px",
    }}
  >
    {/* LEFT SIDE */}
    <div
      style={{
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        alignItems: "center",
      }}
    >
{/* INFO FIRST */}
{/* INFO CHIP */}
<div
  className="ms-2"
  style={{
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "4px 10px",
    borderRadius: "999px",
    background: "#eff6ff", // soft grey background
    border: "1px solid #dbeafe",
    fontSize: "11px",
    color: "#5b6b7c",
    fontWeight: 500,
  }}
>
  {/* Icon */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "20px",
      height: "20px",
      borderRadius: "50%",
      background: "#e0edff",
    }}
  >
    <FiInfo size={12} style={{ color: "#3b82f6" }} />
  </div>

  {/* Text */}
  <span>
    Double-click to edit{" "}
    <span style={{ fontWeight: 600, color: "#334155" }}>
      Current Year, Last Year, Total
    </span>
  </span>
</div>
      </div>
      <div  style={{
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        alignItems: "center",
      }}>
      {/* TOOLBAR BUTTONS */}
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport />

      <Button
        onClick={onImportClick}
        disabled={loading.general}
        sx={{
          opacity: loading.general ? "50%" : "100%",
          display: "flex",
          gap: "8px",
        }}
      >
        <FiUpload size={16} />
        Import
      </Button>
    </div>
  </GridToolbarContainer>
);
    const handleCellEditStart = (params) => {
      setEditingCell({ id: params.id, field: params.field });
    };

    const handleCellEditStop = () => {
      setEditingCell(null);
    };

    const validateBalanceRecord = (record) => {
      const errors = [];
      const label =
        record?.emp_name ||
        record?.emp_id ||
        record?.emp_code ||
        "Unnamed employee";

      balanceNumericFields.forEach((field) => {
        if (!isNumericInputValue(record[field.key])) {
          errors.push(
            `${label}: ${field.label} must contain only numbers (decimals allowed).`
          );
        }
      });

      if (errors.length) return errors;

      const current = toNumericValue(record.current_year);
      const previous = toNumericValue(record.prev_year);
      const total = toNumericValue(record.total);
      if (!doesTotalMatch(current, previous, total)) {
        const expectedTotal = roundToPrecision(current + previous);
        errors.push(
          `${label}: Total is incorrect. It should be 
          ${formatValue(expectedTotal)} based on Current (${formatValue(current)}) and Last (${formatValue(previous)}).`
        );
      }

      return errors;
    };

    const saveLeaveBalanceAsOn = async () => {
      const records = Object.values(editedBalanceRowsRef.current);

      if (!records.length) {
        notify.info("No changes to save");
        return;
      }

      const validationErrors = records.flatMap((record) =>
        validateBalanceRecord(record)
      );

      if (validationErrors.length) {
        setErrors(prev => ({ ...prev, saveValidation: validationErrors }));
        return;
      }

      setErrors(prev => ({ ...prev, saveValidation: [] }));
      setLoading(true);
      try {
        const payloadRecords = records.map((record) => ({
          ...record,
          current_year: toNumericValue(
            record.current_year
          ),
          prev_year: toNumericValue(
            record.prev_year
          ),
          total: toNumericValue(record.total),
        }));

        await ApiClient.put(
          `${process.env.REACT_APP_BASE_URL}/admin/updateLeaveBalanceAsOn`,
          { records: payloadRecords, updated_by: user.name }
        );
        notify.success("Leave balance updated successfully");
        await getLeaveBalanceAsOn();
        await fetchLeaveBalanceHistory(balanceT.empName);
        setErrors(prev => ({ ...prev, import: [] }));
      } catch (error) {
        console.log(error);
        let errmsg = error?.response
          ? error?.response?.data?.message
            ? error?.response?.data?.message
            : `${error?.response?.status} - ${error?.response?.statusText}`
          : "Something went wrong. Please try again later";
        notify.error(errmsg);
      }
      setLoading(prev => ({ ...prev, general: false }));
    };

    const handleSaveLeaveBalance = async () => {
      // if (false) {
      //   // gridApiRef.current.stopCellEditMode({
      //     id: editingCell.id,
      //     field: editingCell.field,
      //   });
      // }
      await saveLeaveBalanceAsOn();
    };

    const handleUndoLeaveBalanceChanges = async () => {
      if (!Object.keys(editedBalanceRowsRef.current).length) return;
      // if (false) {
      //   // gridApiRef.current.stopCellEditMode({
      //     id: editingCell.id,
      //     field: editingCell.field,
      //   });
      // }
      setErrors(prev => ({ ...prev, saveValidation: [] }));
      setEditedBalanceRows({});
      editedBalanceRowsRef.current = {};
      await getLeaveBalanceAsOn();
    };

  const openImportDialog = () => {
    setModalStep(0);
    setErrors(prev => ({ ...prev, import: [] }));
    setImportPreviewData([]);
    setShowImportModal(true);
  };

const downloadTemplate = (type = "xlsx") => {
  const headers = ["Emp ID", "Name", "Current Year", "Last Year", "Total"];

  // Create sheet
  const worksheet = XLSX.utils.aoa_to_sheet([headers]);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Template");

  if (type === "csv") {
    // ✅ CSV download
    const csv = XLSX.utils.sheet_to_csv(worksheet);

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Leave_Balance_Template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    // ✅ XLSX download
    XLSX.writeFile(workbook, "Leave_Balance_Template.xlsx");
  }
};

    const handleDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();

      const file = e.dataTransfer.files?.[0];
      if (!file) return;

      // 🔥 manually call your existing handler
      handleLeaveBalanceImport({
        target: { files: [file], value: null },
      });
    };

    const handleDragOver = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    const handleDragLeave = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    const normalizeImportValue = (value) => {
      const trimmed = getTrimmedValue(value);

      if (trimmed === "") return 0;

      const parsed = Number(trimmed);

      // ❌ reject invalid numbers instead of silently converting
      if (!Number.isFinite(parsed)) return null;

      return parsed;
    };
    const hasChanges = importPreviewData.some(
      item => item.isValid && item.isChanged
    );

    const isRowChanged = (actual, proposed) => {      
      return (
        formatValue(Number(actual.current_year)) !== formatValue(Number(proposed.current)) ||
        formatValue(Number(actual.prev_year)) !== formatValue(Number(proposed.last)) ||
        formatValue(Number(actual.total)) !== formatValue(Number(proposed.total))
      );
    };
  const handleLeaveBalanceImport = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      const buffer = await file.arrayBuffer();
      const workbook = XLSX.read(buffer, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const importedRows = XLSX.utils.sheet_to_json(worksheet, {
        defval: "",
        raw: false,
      });

      if (!importedRows.length) {
        notify.error("Imported file is empty");
            if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
        setErrors(prev => ({ ...prev, import: [] }));
        return;
      }

      const requiredHeaders = [
        "Emp ID",
        "Name",
        "Current Year",
        "Last Year",
        "Total",
      ];
      const normalizedSheetHeaders = Object.keys(importedRows[0]).map(normalizeTrimAndLowercase);

      const missingHeaders = requiredHeaders.filter(
        (header) => !normalizedSheetHeaders.includes(normalizeTrimAndLowercase(header))
      );

      if (missingHeaders.length) {
        // notify.error(`Missing columns: ${missingHeaders.join(", ")}`);
        setErrors(prev => ({
          ...prev,
          import: [`Data looks wrong. Missing columns: ${missingHeaders.join(", ")}`]
        }));
        return;
      }

      // Create maps for quick lookup with normalized keys
      const idMap = new Map();
      const nameMap = new Map();
      const fullMap = new Map();
            console.log("Comparing:", "with");
      leavesBalanceAsOn.forEach(row => {
        const id = String(row.emp_id || "").trim();
        const normId = id; // Remove leading zeros for flexible matching
        const name = String(row.emp_name || "").trim().toLowerCase();
        
        idMap.set(id, row);
        if (normId) idMap.set(normId, row);
        nameMap.set(name, row);
        fullMap.set(`${id}__${name}`, row);
        if (normId) fullMap.set(`${normId}__${name}`, row);
      });
      console.log("JOFEJWO")

      const validationErrors = [];
      const matchedRows = [];
            console.log("Comparing:", "with");
        importedRows.forEach((item, index) => {
          const rowNumber = index + 2;
          const rawId = String(getValue(item, "Emp ID")).trim();
          const normId = rawId;
          const rawName = String(getValue(item, "Name")).trim();
          const normName = rawName.toLowerCase();
          
          const rawCurrentValue =
            item["Current Year"] ?? item["current_year"];
          const rawLastYearValue =
            item["Last Year"] ?? item["prev_year"];
          const rawTotalValue =
            item["Total"] ?? item["total"];

          if (!isNumericInputValue(rawCurrentValue)) {
            validationErrors.push(
              `Row ${rowNumber}: Current Year must contain only numeric characters.`
            );
            return;
          }

          if (!isNumericInputValue(rawLastYearValue)) {
            validationErrors.push(
              `Row ${rowNumber}: Last Year must contain only numeric characters.`
            );
            return;
          }

          if (!isNumericInputValue(rawTotalValue)) {
            validationErrors.push(
              `Row ${rowNumber}: Total must contain only numeric characters.`
            );
            return;
          }

          const currentYear = normalizeImportValue(rawCurrentValue);
          const lastYear = normalizeImportValue(rawLastYearValue);
          const total = normalizeImportValue(rawTotalValue);

          if (currentYear === null || lastYear === null || total === null) {
            validationErrors.push(
              `Row ${rowNumber}: Please provide numeric values for current, last, and total balances.`
            );
            return;
          }

          if (!rawId || !rawName) {
            validationErrors.push(`Row ${rowNumber}: Emp ID or Name is missing`);
            return;
          }

        // Try exact match first, then numeric ID + Name match
        let matchedRow = fullMap.get(`${rawId}__${normName}`) || fullMap.get(`${normId}__${normName}`);
          console.log(matchedRow,'fjaoweofe');
          
        if (!matchedRow) {
          // If no perfect match, find why
          const idMatch = idMap.get(rawId) || idMap.get(normId);
          if (idMatch) {
            validationErrors.push(
              `Row ${rowNumber}: Name mismatch for Emp ID ${rawId} (Expected: ${idMatch.emp_name}, Got: ${rawName})`
            );
          } else {
            validationErrors.push(
              `Row ${rowNumber}: Employee with ID ${rawId} not found in database`
            );
          }
          return;
        }

          const expectedTotal = currentYear + lastYear;
          if (!doesTotalMatch(currentYear, lastYear, total)) {
            validationErrors.push(
                    `Row ${rowNumber}: Total is incorrect. It should be 
                    ${formatValue(expectedTotal)} based on Current (${formatValue(currentYear)}) and Last (${formatValue(lastYear)}).`
            );
            return;
          }

          matchedRows.push({
            ...matchedRow,
            current_year: currentYear,
            prev_year: lastYear,
            total: total,
          });
        });

      setErrors(prev => ({ ...prev, import: validationErrors }));

      console.log("JOFEJWO")
      // Combine matched rows and error rows for the preview
      const preview = [];
      console.log("Comparing:", "with",matchedRows);
      // Add valid matched rows
      matchedRows.forEach(newRow => {
        if (!newRow || !newRow.emp_code) return; // ✅ skip bad rows
        const actualRow = leavesBalanceAsOn.find(r => r.emp_code === newRow.emp_code);

        const hasChanged = isRowChanged(actualRow, {
          current: newRow.current_year,
          last: newRow.prev_year,
          total: newRow.total
        });

        preview.push({
          emp_id: newRow.emp_id,
          emp_name: newRow.emp_name,
          emp_code: newRow.emp_code,
          isValid: true,
          isChanged: hasChanged,   // ✅ NEW
          actual: {
            current: actualRow?.current_year || 0,
            last: actualRow?.prev_year || 0,
            total: actualRow?.total || 0
          },
          proposed: {
            current: newRow.current_year,
            last: newRow.prev_year,
            total: newRow.total
          }
        });
      });

      // Add invalid rows to preview
        importedRows.forEach((item, index) => {
          const rawId = String(getValue(item, "Emp ID")).trim();
          const normId = rawId;
          const rawName = String(getValue(item, "Name")).trim();
          const normName = rawName.toLowerCase();
          let matchedRow = fullMap.get(`${rawId}__${normName}`) || fullMap.get(`${normId}__${normName}`);
          const actualRow = leavesBalanceAsOn.find(r => r?.emp_code === matchedRow?.emp_code);
          console.log(item, index,actualRow,'fjeawoo');
          
          const rowNumber = index + 2;
          const empId = String(item["Emp ID"] || "").trim();
          const empName = String(item["Name"] || "").trim();
          const rowId = `${empId}__${empName.toLowerCase()}`;

        if (matchedRows.find(r => `${r.emp_id.trim()}__${r.emp_name.toLowerCase().trim()}` === rowId)) return;

        // Find the specific error message for this row
        const errorMsg =
          validationErrors
            ?.filter((e) => e.includes(`Row ${rowNumber}:`))
            ?.map((e) => e.replace(`Row ${rowNumber}: `, ""))
            ?.join(", ") || "Employee not found or data mismatch";
        preview.push({
          emp_id: empId || "N/A",
          emp_name: empName || "N/A",
          isValid: false,
          errorMessage: errorMsg,
            actual: {
            current: actualRow?.current_year || '-',
            last: actualRow?.prev_year || '-',
            total: actualRow?.total || '-'
          },
          proposed: { 
            current: item["Current Year"] || 0,
            last: item["Last Year"] || 0,
            total: item["Total"] || 0
          }
        });
      });

      setImportPreviewData(preview);
      setModalStep(1); 
      // Removed toast to avoid double-alerting since the table shows the errors now.

      if (validationErrors.length) {
        // toast.warning("Issues found in your file. Please review the errors in the table.");
      }
    } catch (error) {
      console.log(error);
      setErrors(prev => ({ ...prev, import: ["Data looks wrong or file could not be read"] }));
      notify.error("Unable to import file");
    }
    event.target.value = null;
  };

  const fetchLeaveBalanceHistory = async (code) => {
  setDisableLeave(true);
    try {
      setLoading(prev => ({ ...prev, history: true }));
      const { data } = await ApiClient.post(
        `${process.env.REACT_APP_BASE_URL}/admin/getLeaveBalanceHistory`,
        { code },
        { headers: { skipLoader: true } }
      );
      setLeaveBalanceHistory(Array.isArray(data) ? data : []);
    } catch (error) {
      console.log(error);
      notify.error("Unable to load history");
    } finally {
      setLoading(prev => ({ ...prev, history: false }));
      setDisableLeave(false);
    }
  };

  const confirmImportSave = async () => {
    const changedRecords = importPreviewData.filter(
      item => item.isValid && item.isChanged
    );

    if (!changedRecords.length) {
      notify.info("No changes detected. Nothing to update.");
      return;
    }
    const records = changedRecords?.map(item => ({
      emp_code: item.emp_code,
      emp_id: item.emp_id,
      emp_name: item.emp_name,
      current_year: formatValue(item.proposed.current),
      prev_year: formatValue(item.proposed.last),
      total: formatValue(item.proposed.total)
    }));

    setLoading(prev => ({ ...prev, general: true }));
    try {
      await ApiClient.put(
        `${process.env.REACT_APP_BASE_URL}/admin/updateLeaveBalanceAsOn`,
        { records, updated_by: user.name }
      );
      notify.success("Imported leave balances saved successfully");
      setShowImportModal(false);
      setImportPreviewData([]);
      await getLeaveBalanceAsOn();
      await fetchLeaveBalanceHistory(balanceT.empName);
      setErrors(prev => ({ ...prev, import: [] }));
    } catch (error) {
      console.log(error);
      notify.error("Failed to save imported changes");
    }
    setLoading(prev => ({ ...prev, general: false }));
  };

  const getLeavesBalanceByDate = async () => {
    try {
      if (balanceT.startDate && balanceT.endDate) {
        if (new Date(balanceT.startDate) <= new Date(balanceT.endDate)) {
          const { data } = await ApiClient.post(
            `${process.env.REACT_APP_BASE_URL}/admin/getLeaveBalance`,
            {
              code: balanceT.empName,
              startDt: balanceT.startDate,
              endDt: balanceT.endDate,
            }
          );
          if (data.length === 0) {
            notify.error("No matching records found");
          } else {
            data?.map(
              (ele) =>
                (ele.NO_OF_DAYS = findNoOfDays(ele.START_DATE, ele.END_DATE))
            );
            let leaveTableCols = [
              {
                headerName: "Emp ID",
                field: "EMP_ID",
                sortable: true,
                width: 100,
              },
              {
                headerName: "Name",
                field: "EMP_NAME",
                sortable: true,
                width: 220,
              },
              {
                headerName: "Accepted Leave",
                field: "AcceptedNo",
                sortable: true,
                width: 200,
              },
              {
                headerName: "Pending Leave",
                field: "PendingNO",
                sortable: true,
                width: 200,
              },
              {
                headerName: "Current Year Leave Balance",
                field: "CURRENT_YEAR_LEAVE_BALANCE",
                sortable: true,
                width: 250,
                valueFormatter: (params) => params?.value != null ? formatValue(params.value) : "",
              },
              {
                headerName: "Previous Year Leave Balance",
                field: "TOTAL_LEAVE_BALANCE",
                sortable: true,
                width: 250,
                valueFormatter: (params) => params?.value != null ? formatValue(params.value) : "",
              },
            ];
            setColumnsBalance(leaveTableCols);

            console.log(data);
            const result = data.reduce((acc, item) => {
              const existingItem = acc.find(
                (element) => element.EMP_CODE === item.EMP_CODE
              );
              if (existingItem) {
                if (item.LEAVE_STATUS === null) {
                  existingItem.PendingNO += parseFloat(item.NO_OF_DAYS);
                } else if (item.LEAVE_STATUS == "Accepted") {
                  existingItem.AcceptedNo += parseFloat(item.NO_OF_DAYS);
                }
              } else {
                const newItem = {
                  EMP_ID: item.EMP_ID,
                  EMP_CODE: item.EMP_CODE,
                  EMP_NAME: item.EMP_NAME,
                  CURRENT_YEAR_LEAVE_BALANCE: parseFloat(
                    item.CURRENT_YEAR_LEAVE_BALANCE || 0
                  ),
                  TOTAL_LEAVE_BALANCE: parseFloat(item.TOTAL_LEAVE_BALANCE || 0),
                  PendingNO: item.LEAVE_STATUS === null ? item.NO_OF_DAYS : 0,
                  AcceptedNo:
                    item.LEAVE_STATUS === "Accepted" ? item.NO_OF_DAYS : 0,
                };
                acc.push(newItem);
              }
              return acc;
            }, []);
            setLeavesBalance(result);
          }
          setDisableLeave(false);
        } else notify.error("Start Date should be less than End Date");
      } else {
        setDisableLeave(false);
        notify.error("Start Date and End Date fields are mandatory");
      }
    } catch (error) {
      console.log(error);
      setDisableLeave(false);
      let errmsg = error?.response
        ? error?.response?.data?.message
          ? error?.response?.data?.message
          : `${error?.response?.status} - ${error?.response?.statusText}`
        : "Something went wrong. Please try again later";
      notify.error(errmsg);
    }
  };

  const raiseLeave = async () => {
    setApplyLeaveError("");
    if (
      state.empName1 &&
      state.startDate &&
      state.endDate &&
      state.noOfDays &&
      state.leaveType
    ) {
      const emp = employees.find((item) => item.EMP_CODE === state.empName1);
      const empName = emp.EMP_NAME;
      if (new Date(state.startDate) <= new Date(state.endDate)) {
        if (state.startDate === state.endDate && state.noOfDays && Number(state.noOfDays) !== 0.5 && Number(state.noOfDays) !== 1) {
          setApplyLeaveError("Number of Days must be 0.5 or 1 for the same day");
          return;
        }
        try {
          setIsDisabled(true);
          const { data } = await ApiClient.post(
            `${process.env.REACT_APP_BASE_URL}/admin/raiseLeave`,
            {
              empcode: state.empName1,
              empName: empName,
              startDate: state.startDate,
              endDate: state.endDate,
              days: state.noOfDays,
              leaveType: state.leaveType,
              approvedBy: user.name,
            }
          );
          notify.success("Leave added successfully");
          setState(initialState);
          setIsDisabled(false);
        } catch (error) {
          console.log(error);
          setIsDisabled(false);
          let errmsg = error?.response
            ? error?.response?.data?.message
              ? error?.response?.data?.message
              : `${error?.response?.status} - ${error?.response?.statusText}`
            : "Something went wrong. Please try again later";
          setApplyLeaveError(errmsg);
        }
      } else setApplyLeaveError("Start Date should be less than or equal to End Date");
    } else {
      setApplyLeaveError("All fields are mandatory");
    }
  };

  const initDateRange = () => {
    const minsec = ms("0d");
    const min_date = new Date(new Date(state.startDate) - minsec);
    setMinDate1(moment(min_date).format("YYYY-MM-DD"));
  };

  const initRangeForLeave = () => {
    const minsec = ms("0d");
    const min_date = new Date(new Date(state.startDt) - minsec);
    setMinDate2(moment(min_date).format("YYYY-MM-DD"));
  };

  useEffect(() => {
    initDateRange();
  }, [state.startDate]);

  useEffect(() => {
    initRangeForLeave();
  }, [state.startDt]);

  useEffect(() => {
  const fetchAll = async () => {
    setLoading(prev => ({ ...prev, isInitial: true }));
    await fetchNewLeaves();
    setLoading(prev => ({ ...prev, isInitial: false }));
  };
  fetchAll();
}, [user]);

  useEffect(() => {
    if (user?.role !== "Manager") {
      getLeaveBalanceAsOn();
      fetchLeaveBalanceHistory(balanceT.empName);
    }
  }, [user, balanceT.empName]);


  useEffect(() => {
    if (!initialFetchDone && state.startDt && state.endDt) {
      getLeavesByDate();
      setInitialFetchDone(true);
    }
  }, [state.startDt, state.endDt, initialFetchDone]);

  return (
    <div className="flex flex-col h-full relative overflow-y-auto w-full space-y-3">
      {/* Top Row: 70/30 Split */}
      {!hideExtraTabs && (
      <div className="flex flex-col lg:flex-row gap-3 items-stretch">
        {/* Left Side 70% */}
        <div className="flex-1 flex flex-col min-w-0 w-full">
          {user?.role !== "Manager" && (
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col h-full">
              <div className="flex-1 p-0 relative min-h-0">
                <CentralizedTable isLoading={loading.isInitial || disableLeave}
                  getRowId={(row) =>
                    row.EMP_NAME + row.START_DATE + row.END_DATE + row.LEAVE_STATUS
                  }
                  rows={newLeaves}
                  columns={newLeaveCols}
                  renderTopToolbarCustomActions={() => (
                <div className="flex items-center gap-3 py-2">
  {/* Icon */}
  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-orange-100 bg-orange-50">
    <ClipboardList
      size={17}
      strokeWidth={2.2}
      className="text-orange-600"
    />
  </div>

  {/* Content */}
  <div className="min-w-0">
    <div className="flex items-center gap-2">
      <h2 className="text-[16px] font-semibold tracking-tight text-slate-900">
        Pending Leave Requests
      </h2>

      {newLeaves.length > 0 && (
        <span className="inline-flex h-6 min-w-[24px] items-center justify-center rounded-full bg-orange-100 px-2 text-xs font-semibold text-orange-700">
          {newLeaves.length}
        </span>
      )}
    </div>

  </div>
</div>
                  )}
                  customInternalActions={() => (
                    newLeaves.length > 0 && (
                      <button
                        type="button"
                        onClick={() => setIsAcceptAllModalOpen(true)}
                        disabled={loading.general || actionLoading !== null}
                        className={`whitespace-nowrap px-2.5 py-1.5 border border-blue-200 text-blue-600 bg-white shadow-sm text-sm font-medium rounded-[6px] transition-colors flex items-center gap-2 ml-2 ${actionLoading !== null ? 'cursor-not-allowed opacity-50' : 'hover:bg-blue-50'}`}
                      >
                        {actionLoading?.type === 'acceptAll' ? <div className="w-4 h-4 border-2 border-blue-600/30 border-t-blue-600 rounded-full animate-spin" /> : <CheckCircle2 size={16} />}
                        Accept All
                      </button>
                    )
                  )}
                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: 5, page: 0 },
                    },
                    columnPinning: { right: ['LEAVE_ACTION'] }
                  }}
                  pageSizeOptions={[5, 10, 25, 50]}
                  enableColumnPinning={true}
                  hideFooterSelectedRowCount
                  muiTableHeadCellProps={({ column }) => ({
                      sx: {
                          whiteSpace: "nowrap",
                          py: "8px",
                          px: column.getIndex() === 0 ? "16px" : "3px",
                          borderBottom: "1px solid #e2e8f0",
                          boxShadow: 'none !important',
                          '&::before': {
                              boxShadow: column.id === 'LEAVE_ACTION' ? '-4px 0 10px rgba(0,0,0,0.05) !important' : 'none !important',
                          }
                      }
                  })}
                  muiTableBodyCellProps={({ cell }) => ({
                      sx: {
                          py: "8px",
                          borderBottom: "1px solid #e2e8f0",
                          px: cell.column.getIndex() === 0 ? '16px' : "3px",
                          overflow: cell.column.id === 'LEAVE_ACTION' ? 'visible' : 'hidden',
                          textOverflow: cell.column.id === 'LEAVE_ACTION' ? 'clip' : 'ellipsis',
                          backgroundColor: cell.column.id === 'LEAVE_ACTION' ? '#fff !important' : 'inherit',
                          boxShadow: 'none !important',
                          '&::before': {
                              boxShadow: cell.column.id === 'LEAVE_ACTION' ? '-4px 0 10px rgba(0,0,0,0.05) !important' : 'none !important',
                          }
                      },
                  })}
                  muiTableContainerProps={{
                      sx: {
                          minHeight: '100px',
                          height: 'auto',
                          flex: 1,
                          overflow: 'auto'
                      },
                  }}
                />
              </div>
            </div>
          )}
        </div>

        {/* Right Side 30% */}
        <div className="w-full lg:w-[320px] xl:w-[360px] shrink-0">
          {user?.role !== "Manager" && (
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 flex flex-col h-full">
              <div className="flex items-center gap-3 shrink-0 px-2">
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-green-100 bg-green-50">
                  <CalendarCheck
                    size={17}
                    strokeWidth={2.2}
                    className="text-green-600"
                  />
                </div>
                <div>
                  <h4 className="text-[16px] font-semibold text-slate-800 m-0 leading-tight">On-Behalf Leave</h4>
                  <p className="text-xs text-slate-500 mt-1 mb-0 hidden sm:block">Raise a leave request for an employee.</p>
                </div>
              </div>
              
              <div className="space-y-4 pb-1 pt-4 overflow-y-auto flex-1 custom-scrollbar max-h-[650px] px-1">
                  <div className="w-full">
                    <label className="block text-[13px] font-semibold text-slate-700 mb-1.5">Employee Name <span className="text-red-500">*</span></label>
                    <Autocomplete
                      options={employees?.filter(el => el.STATUS === "Active") || []}
                      getOptionLabel={(option) => `${option.EMP_NAME} - ${option.EMP_ID || ""}`}
                      isOptionEqualToValue={(option, value) => option.EMP_CODE === value.EMP_CODE}
                      value={employees?.find(emp => emp.EMP_CODE === state.empName1) || null}
                      onChange={(e, val) => handleChange({ target: { name: "empName1", value: val ? val.EMP_CODE : "" } })}
                      size="small"
                      fullWidth
                      className="bg-white"
                      ListboxProps={{ sx: { fontSize: '14px', '& .MuiAutocomplete-option': { fontSize: '14px' } } }}
                      sx={{
                          '& .MuiOutlinedInput-root': { 
                              height: '36px', 
                              minHeight: '36px', 
                              fontSize: '14px',
                              borderRadius: '0.5rem',
                              paddingTop: '0',
                              paddingBottom: '0',
                              paddingLeft: '8px',
                              '& fieldset': { borderColor: '#e2e8f0' },
                              '&:hover fieldset': { borderColor: '#cbd5e1' },
                              '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: '1px' }
                          },
                          '& .MuiAutocomplete-input': {
                              padding: '0 !important',
                          }
                      }}
                      renderInput={(params) => (
                          <TextField 
                              {...params} 
                              placeholder="Select Employee" 
                          />
                      )}
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div className="w-full">
                      <label className="block text-[13px] font-semibold text-slate-700 mb-1.5">Start Date <span className="text-red-500">*</span></label>
                      <TextField
                        name="startDate"
                        type="date"
                        value={state.startDate}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                        className="bg-white"
                        sx={{ 
                            '& .MuiOutlinedInput-root': { 
                                height: '36px', 
                                minHeight: '36px', 
                                fontSize: '14px',
                                borderRadius: '0.5rem',
                                '& fieldset': { borderColor: '#e2e8f0' },
                                '&:hover fieldset': { borderColor: '#cbd5e1' },
                                '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: '1px' }
                            } 
                        }}
                      />
                    </div>
                    <div className="w-full">
                      <label className="block text-[13px] font-semibold text-slate-700 mb-1.5">End Date <span className="text-red-500">*</span></label>
                      <TextField
                        name="endDate"
                        type="date"
                        value={state.endDate}
                        onChange={handleChange}
                        size="small"
                        inputProps={{ min: minDate1 }}
                        fullWidth
                        className="bg-white"
                        sx={{ 
                            '& .MuiOutlinedInput-root': { 
                                height: '36px', 
                                minHeight: '36px', 
                                fontSize: '14px',
                                borderRadius: '0.5rem',
                                '& fieldset': { borderColor: '#e2e8f0' },
                                '&:hover fieldset': { borderColor: '#cbd5e1' },
                                '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: '1px' }
                            } 
                        }}
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div className="w-full">
                      <label className="block text-[13px] font-semibold text-slate-700 mb-1.5">Number of Days {state.startDate && state.endDate && state.startDate === state.endDate ? <span className="text-red-500">*</span> : "" }</label>
                      <TextField
                        name="noOfDays"
                        type="number"
                        value={state.noOfDays}
                        onChange={handleChange}
                        size="small"
                        inputProps={{ min: 0.5, step: 0.5, max: (state.startDate && state.endDate && state.startDate === state.endDate) ? 1 : 30 }}
                        fullWidth
                        disabled={state.startDate && state.endDate && state.startDate !== state.endDate}
                        className="bg-white"
                        sx={{ 
                            '& .MuiOutlinedInput-root': { 
                                height: '36px', 
                                minHeight: '36px', 
                                fontSize: '14px',
                                borderRadius: '0.5rem',
                                '& fieldset': { borderColor: (state.startDate && state.endDate && state.startDate === state.endDate && state.noOfDays !== "" && Number(state.noOfDays) !== 0.5 && Number(state.noOfDays) !== 1) ? '#ef4444' : '#e2e8f0' },
                                '&:hover fieldset': { borderColor: (state.startDate && state.endDate && state.startDate === state.endDate && state.noOfDays !== "" && Number(state.noOfDays) !== 0.5 && Number(state.noOfDays) !== 1) ? '#ef4444' : '#cbd5e1' },
                                '&.Mui-focused fieldset': { borderColor: (state.startDate && state.endDate && state.startDate === state.endDate && state.noOfDays !== "" && Number(state.noOfDays) !== 0.5 && Number(state.noOfDays) !== 1) ? '#ef4444' : '#3b82f6', borderWidth: '1px' }
                            } 
                        }}
                      />
                    </div>
                    <div className="w-full">
                      <label className="block text-[13px] font-semibold text-slate-700 mb-1.5">Leave Type <span className="text-red-500">*</span></label>
                      <Select
                        name="leaveType"
                        value={state.leaveType || ""}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                        className="bg-white"
                        MenuProps={selectMenuProps}
                        sx={{
                            '& .MuiSelect-select': {
                                paddingRight: '32px !important',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                fontSize: '14px',
                                paddingTop: '8px',
                                paddingBottom: '8px'
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#e2e8f0'
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#cbd5e1'
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#3b82f6',
                                borderWidth: '1px'
                            },
                            borderRadius: '0.5rem',
                            height: '36px'
                        }}
                      >
                        <MenuItem disabled value="">Select Leave Type</MenuItem>
                        {leaveOptions?.map((leave) => (
                          <MenuItem key={leave.value} value={leave.value}>
                            {leave.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>

                  <div className="pt-2 shrink-0">
                    {applyLeaveError && (
                      <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-red-700 text-xs flex items-start gap-2 mb-3">
                        <AlertCircle size={15} className="shrink-0" />
                        <span className="leading-tight">{applyLeaveError}</span>
                      </div>
                    )}
                    <button
                      onClick={raiseLeave}
                      disabled={isDisabled}
                      className="w-full h-[36px] px-6 bg-brand-600 text-white text-sm font-semibold rounded-lg hover:bg-brand-700 focus:ring-4 focus:ring-brand-500/20 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm flex justify-center items-center gap-2"
                    >
                      {isDisabled ? <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" /> : null}
                      Raise Leave
                    </button>
                  </div>
                </div>
            </div>
          )}
        </div>
      </div>
      )}

      {/* Bottom Row: Tabs */}
      <div className={`bg-white rounded-2xl shadow-sm ${hideExtraTabs ? 'border-none shadow-none' : 'border border-slate-200'} overflow-hidden flex flex-col flex-1`}>
        {!hideExtraTabs && (
        <div className="flex overflow-x-auto custom-scrollbar border-b border-slate-200 sticky top-0 z-10 shrink-0">
          <button
            onClick={() => setBottomTab('records')}
            className={`flex whitespace-nowrap shrink-0 items-center gap-2 px-6 py-4 text-sm font-semibold border-b-2 transition-all ${
              bottomTab === 'records'
                ? 'border-brand-600 text-brand-700 bg-white'
                : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-slate-50'
            }`}
          >
            Request History
          </button>
          <button
            onClick={() => setBottomTab('balances')}
            className={`flex whitespace-nowrap shrink-0 items-center gap-2 px-6 py-4 text-sm font-semibold border-b-2 transition-all ${
              bottomTab === 'balances'
                ? 'border-brand-600 text-brand-700 bg-white'
                : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-slate-50'
            }`}
          >
            Leave Balance Update
          </button>
          <button
            onClick={() => setBottomTab('history')}
            className={`flex whitespace-nowrap shrink-0 items-center gap-2 px-6 py-4 text-sm font-semibold border-b-2 transition-all ${
              bottomTab === 'history'
                ? 'border-brand-600 text-brand-700 bg-white'
                : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-slate-50'
            }`}
          >
            Updated Leave History
          </button>
          <button
            onClick={() => setBottomTab('lop')}
            className={`flex whitespace-nowrap shrink-0 items-center gap-2 px-6 py-4 text-sm font-semibold border-b-2 transition-all ${
              bottomTab === 'lop'
                ? 'border-brand-600 text-brand-700 bg-white'
                : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-slate-50'
            }`}
          >
            LOP Tracker
          </button>
        </div>
        )}

        {/* Tab Content */}
        <div className="p-0 flex-1 flex flex-col overflow-y-auto">
          {bottomTab === 'records' && (
            <div className="p-0 flex flex-col h-full">
                <div className="p-4 border-b border-slate-200 bg-slate-50/50">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 items-end w-full">
                        <div className="w-full">
                            <label className="block text-xs font-bold text-slate-700 mb-1.5 uppercase tracking-wide">Employee Name</label>
                            <Autocomplete
                                multiple
                                limitTags={1}
                                disableCloseOnSelect
                                renderTags={() => null}
                                options={activeEmployees}
                                getOptionLabel={(option) => option ? `${option.EMP_NAME} (${option.EMP_ID})` : ""}
                                isOptionEqualToValue={(option, value) => option.EMP_CODE === value.EMP_CODE}
                                renderOption={(props, option, { selected }) => {
                                    const { key, ...restProps } = props;
                                    return (
                                        <li key={option.EMP_CODE || key} {...restProps}>
                                            <div className="flex items-center w-full">
                                                <span className={`flex-1 ${selected ? 'font-semibold' : ''}`}>{option.EMP_NAME} ({option.EMP_ID})</span>
                                            </div>
                                        </li>
                                    );
                                }}
                                value={state.empName2}
                                onChange={(e, val) => setState({ ...state, empName2: val })}
                                size="small"
                                className="w-full bg-white text-sm"
                                ListboxProps={{ sx: { fontSize: '14px' } }}
                                renderInput={(params) => <TextField {...params} placeholder={state.empName2.length > 0 ? `${state.empName2.length} Selected` : "All Employees"} />}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        minHeight: '40px',
                                        paddingTop: '0 !important',
                                        paddingBottom: '0 !important',
                                        fontSize: '14px'
                                    },
                                    '& .MuiAutocomplete-input': {
                                        paddingTop: '0 !important',
                                        paddingBottom: '0 !important',
                                    }
                                }}
                            />
                        </div>
                        <div className="w-full">
                            <label className="block text-xs font-bold text-slate-700 mb-1.5 uppercase tracking-wide">Leave Type</label>
                            <Select 
                                size="small" 
                                fullWidth 
                                name="filterLeaveType"
                                value={state.filterLeaveType} 
                                onChange={handleChange} 
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            maxHeight: 250,
                                            marginTop: '4px',
                                            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                                            '& .MuiMenuItem-root': {
                                                fontSize: '14px',
                                                whiteSpace: 'normal',
                                                wordBreak: 'break-word'
                                            }
                                        }
                                    },
                                }}
                                className="bg-white"
                                sx={{ 
                                    height: '40px', 
                                    fontSize: '14px',
                                    '& .MuiSelect-select': {
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }
                                }}
                            >
                                <MenuItem value="All">All Types</MenuItem>
                                {leaveOptions.map(leave => (
                                    <MenuItem key={leave.value} value={leave.value}>{leave.label}</MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div className="w-full">
                            <label className="block text-xs font-bold text-slate-700 mb-1.5 uppercase tracking-wide">Start Date <span className="text-red-500">*</span></label>
                            <TextField 
                                type="date" 
                                size="small" 
                                fullWidth
                                name="startDt"
                                value={state.startDt} 
                                onChange={handleChange} 
                                InputLabelProps={{ shrink: true }} 
                                className="bg-white"
                                sx={{ '& .MuiOutlinedInput-root': { height: '40px', minHeight: '40px', fontSize: '14px' } }}
                            />
                        </div>
                        <div className="w-full">
                            <label className="block text-xs font-bold text-slate-700 mb-1.5 uppercase tracking-wide">End Date <span className="text-red-500">*</span></label>
                            <TextField 
                                type="date" 
                                size="small" 
                                fullWidth
                                name="endDt"
                                value={state.endDt} 
                                onChange={handleChange} 
                                InputLabelProps={{ shrink: true }} 
                                className="bg-white"
                                sx={{ '& .MuiOutlinedInput-root': { height: '40px', minHeight: '40px', fontSize: '14px' } }}
                            />
                        </div>
                        <div className="w-full">
                            <button
                                onClick={getLeavesByDate}
                                disabled={disableLeave}
                                className="w-full h-[38px] px-6 bg-brand-600 text-white text-sm font-semibold rounded-[6px] hover:bg-brand-700 focus:ring-4 focus:ring-brand-500/20 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm flex justify-center items-center gap-2"
                            >
                                {disableLeave ? <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" /> : null}
                                Search
                            </button>
                        </div>
                    </div>
                    {state.empName2.length > 0 && (
                        <>
                            <hr className="my-5 border-slate-200" />
                            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
                                <div className="flex flex-wrap gap-2 flex-1 items-center">
                                    <span className="text-xs font-bold text-slate-500 uppercase mr-1">Selected Employees:</span>
                                    {state.empName2.map((emp) => (
                                        <Chip 
                                            key={emp.EMP_CODE} 
                                            label={emp.EMP_NAME} 
                                            size="small" 
                                            className='font-semibold'
                                            onDelete={() => {
                                                setState({
                                                    ...state,
                                                    empName2: state.empName2.filter(e => e.EMP_CODE !== emp.EMP_CODE)
                                                })
                                            }}
                                            deleteIcon={<X size={14} strokeWidth={2.5} />}
                                            sx={{ 
                                                backgroundColor: '#eff6ff', 
                                                color: '#2563eb', 
                                                '& .MuiChip-deleteIcon': {
                                                    color: '#3b82f6', 
                                                    '&:hover': { color: '#1d4ed8' } 
                                                }
                                            }}
                                        />
                                    ))}
                                    <button 
                                        onClick={() => setState({ ...state, empName2: [] })}
                                        className="text-[12px] text-red-500 hover:text-red-700 font-medium ml-2 underline underline-offset-2"
                                    >
                                        Clear All
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                <div className="flex-1 overflow-auto relative p-0 m-0 h-full flex flex-col">
                    <CentralizedTable 
                        muiTableBodyRowProps={{ sx: { '& td': { whiteSpace: 'nowrap' } } }}
                        isLoading={loading.isInitial || disableLeave}
                        getRowId={(row) => (row.REQUEST_ID ? String(row.REQUEST_ID) : row.EMP_NAME + row.START_DATE + row.END_DATE + row.LEAVE_STATUS)}
                        rows={leaves}
                        columns={columns}
                        autoHeight
                        renderTopToolbarCustomActions={() => (
                            <div className="flex items-center h-full pt-1">
                                <h4 className="text-base font-bold text-slate-800 m-0">
                                    Request History
                                </h4>
                            </div>
                        )}
                        slots={{
                            toolbar: GridToolbar,
                        }}
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 10, page: 0 },
                            },
                        }}
                        pageSizeOptions={[10, 25, 50]}
                       muiTableContainerProps={{
                                    sx: {
                                        minHeight: "auto",
                                        height: 'auto',
                                        flex: 1,
                                        overflow: 'auto',
                                    },
                                }}
                    />
                </div>
            </div>
          )}
          {bottomTab === 'lop' && (
            <div className="flex flex-col h-full">

              <div id="lopTrackerTable" className="flex-1 overflow-auto relative">
                <CentralizedTable 
                  muiTableBodyRowProps={{ sx: { height: '45px', '& td': { whiteSpace: 'nowrap' } } }}
                  isLoading={loading.isInitial || loading.lop}
                  getRowId={(row) => row.id}
                  rows={lopData}
                  columns={lopColumns}
                  autoHeight
                  renderTopToolbarCustomActions={() => (
           <div className="flex items-center gap-3 py-1">
  {/* Icon */}
  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-red-100 bg-red-50">
    <Activity size={17} strokeWidth={2.2} className="text-red-600" />
  </div>

  {/* Content */}
  <div className="min-w-0">
    <h2 className="text-md font-semibold tracking-tight text-slate-900">
      LOP Tracker
    </h2>

    <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[13px]">

      {/* Cycle */}
      <div className="flex items-center gap-1.5 text-slate-500">
        <CalendarCheck
          size={14}
          strokeWidth={2}
          className="text-slate-400"
        />

        <span>
          Cycle:&nbsp;
          <span className="font-semibold text-slate-700">
            {moment(cycleBounds.start).format("DD MMM YYYY")} –{" "}
            {moment(cycleBounds.end).format("DD MMM YYYY")}
          </span>
        </span>
      </div>

      {/* Divider */}
      <span className="hidden text-slate-300 sm:block">•</span>

      {/* Reset */}
      <div className="flex items-center gap-1.5 text-slate-500">
        <History
          size={14}
          strokeWidth={2}
          className="text-slate-400"
        />

        <span>
          Resets on:&nbsp;
          <span className="font-semibold text-slate-700">
            {moment(cycleBounds.end).add(1, "days").format("DD MMM YYYY")}
          </span>
        </span>
      </div>

    </div>
  </div>
</div>
                    )}
                  slots={{
                    toolbar: GridToolbar,
                    noRowsOverlay: () => (
                      <div className="flex justify-center items-center h-full p-5 text-slate-500">
                        No employees currently have LOP in this cycle.
                      </div>
                    )
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: 10, page: 0 },
                    },
                  }}
                  pageSizeOptions={[10, 25, 50]}
                  hideFooterSelectedRowCount
                     muiTableContainerProps={{
                                    sx: {
                                        minHeight: "auto",
                                        height: 'auto',
                                        flex: 1,
                                        overflow: 'auto',
                                    },
                                }}
                />
              </div>
            </div>
          )}
      {/* {user?.role !== "Manager" && (
        <Card>
          <h4>Leave Balance Tracker</h4>
          <div className="row mt-2">
            <div className="col-md-3">
              <label htmlFor="empName2">Employee Name</label>
              <br />
              <select
                name="empName"
                className="w-full bg-white"
                value={balanceT.empName}
                onChange={handleBalanceChange}
                required
              >
                <option disabled hidden></option>
                {employees &&
                  employees
                    .filter((el) => el.STATUS === "Active")
                    .map((emp) => {
                      return (
                        <option key={emp.EMP_CODE} value={emp.EMP_CODE}>
                          {emp.EMP_NAME}
                        </option>
                      );
                    })}
              </select>
            </div>
            <div className="col-md-3">
              <label htmlFor="startDt">
                Start Date<span >*</span>
              </label>
              <br />
              <TextField size="small"
                name="startDate"
                type="date"
                className="w-full bg-white"
                value={balanceT.startDate}
                onChange={handleBalanceChange}
                required
               InputLabelProps={{ shrink: true }} />
            </div>
            <div className="col-md-3">
              <label htmlFor="endDt">
                End Date<span >*</span>
              </label>
              <br />
              <TextField size="small"
                name="endDate"
                type="date"
                className="w-full bg-white"
                value={balanceT.endDate}
                onChange={handleBalanceChange}
                min={minDate2}
                required
               InputLabelProps={{ shrink: true }} />
            </div>
            <div className="col-md-3">
              <div style={{ float: "right" }}>
                <div style={{ display: "inline-block", marginRight: "10px" }}>
                  <button type="button"  className="px-4 py-2 bg-slate-800 text-white rounded-lg hover:bg-slate-700 transition-colors font-medium shadow-sm CDBBtn"
                    onClick={getLeavesBalanceByDate}
                    disabled={disableLeave}
                    style={{ 
                        opacity: disableLeave ? "50%" : "100%",
                        height: '38px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                    }}
                  >
                    {disableLeave ? (
                        <>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </>
                    ) : "Get Data"}
                  </button>
                </div>
                <div style={{ display: "inline-block", marginRight: "10px" }}>
                  <button type="button"  className="px-4 py-2 bg-slate-800 text-white rounded-lg hover:bg-slate-700 transition-colors font-medium shadow-sm CDBBtn"
                    onClick={() =>
                      setBalanceT({ empName: "", startDate: "", endDate: "" })
                    }
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            id="leaveRecordsTableBalance"
            style={{ display: "none", overflow: "auto" }}
          >
            <CentralizedTable 
              muiTableBodyRowProps={{ sx: { '& td': { whiteSpace: 'nowrap' } } }}
              isLoading={loading.isInitial || disableLeave}
              getRowId={(row) =>
                row.EMP_NAME + row.START_DATE + row.END_DATE + row.LEAVE_STATUS
              }
              
              rows={leavesBalance}
              columns={columnsBalance}
              autoHeight
              
              initialState={{
                pagination: {
                  paginationModel: { pageSize: 10, page: 0 },
                },
              }}
              pageSizeOptions={[10, 25, 50]}
              hideFooterSelectedRowCount
            />
          </div>
        </Card>
      )} */}
          {bottomTab === 'balances' && user?.role !== "Manager" && (
            <div className="flex flex-col h-full">

                <div className="flex-1 overflow-auto relative mt-0">
                  <CentralizedTable 
                    muiTableBodyRowProps={{ sx: { '& td': { whiteSpace: 'nowrap' } } }}
                    isLoading={loading.isInitial || disableLeave}
                    getRowId={(row) => row.emp_code}
                    rows={leavesBalanceAsOn}
                    columns={columnsBalanceAsOn}
                    autoHeight
                    renderTopToolbarCustomActions={() => (
                      <div className="flex items-center justify-between bg-white pt-1 pb-1.5">
                      <div className="flex items-center gap-3">
                        <div className="flex h-9 w-9 items-center justify-center rounded-xl border border-emerald-100 bg-emerald-50">
                          <Edit3 size={17} className="text-emerald-600" />
                        </div>

                        <div>
                          <h2 className="text-md font-semibold tracking-tight text-slate-900">
                            Leave Balance
                          </h2>

                          <div className="flex items-center gap-1.5 sm:gap-2 text-[12px] sm:text-[13px] text-slate-500">
                            <CalendarDays size={14} className="text-slate-400 shrink-0" />

                            <span className="hidden sm:inline-block whitespace-nowrap">Snapshot as on</span>

                            <span className="rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-[11px] sm:text-xs font-medium text-slate-600 whitespace-nowrap">
                              {moment().format("DD MMM YYYY")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    )}
                    customInternalActions={() => (
                      <div>
                        <Tooltip title="Upload Leave Balance">
                          <IconButton 
                            onClick={openImportDialog} 
                            disabled={loading.general} 
                            size="small"
                          >
                            <Upload size={18} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    )}
                    initialState={{
                      pagination: {
                        paginationModel: { pageSize: 10, page: 0 },
                      },
                      columnPinning: { right: ['ACTION'] }
                    }}
                    enableColumnPinning={true}
                    pageSizeOptions={[10, 25, 50]}
                    hideFooterSelectedRowCount
                    disableRowSelectionOnClick
                    muiTableHeadCellProps={({ column }) => ({
                        sx: {
                            boxShadow: 'none !important',
                            '&::before': {
                                boxShadow: column.id === 'ACTION' ? '-4px 0 10px rgba(0,0,0,0.05) !important' : 'none !important',
                            }
                        }
                    })}
                    muiTableBodyCellProps={({ cell }) => ({
                        sx: {
                            py: "8px",
                            borderBottom: "1px solid #e2e8f0",
                            px: cell.column.getIndex() === 0 ? '16px' : "3px",
                            overflow: cell.column.id === 'ACTION' ? 'visible' : 'hidden',
                            textOverflow: cell.column.id === 'ACTION' ? 'clip' : 'ellipsis',
                            backgroundColor: cell.column.id === 'ACTION' ? '#fff !important' : 'inherit',
                            boxShadow: 'none !important',
                            '&::before': {
                                boxShadow: cell.column.id === 'ACTION' ? '-4px 0 10px rgba(0,0,0,0.05) !important' : 'none !important',
                            }
                        },
                    })}
                      muiTableContainerProps={{
                                    sx: {
                                        minHeight: "auto",
                                        height: 'auto',
                                        flex: 1,
                                        overflow: 'auto',
                                    },
                                }}
                  />
                </div>
            </div>
          )}
          {bottomTab === 'history' && user?.role !== "Manager" && (
            <div className="flex flex-col h-full">
              <div className="flex-1 overflow-auto relative">
                  <CentralizedTable 
                    muiTableBodyRowProps={{ sx: { height: '45px', '& td': { whiteSpace: 'nowrap' } } }}
                    isLoading={loading.isInitial || loading.history || disableLeave}
                    getRowId={(row) =>
                      row.id || `${row.emp_code}-${row.updated_at}`
                    }
                    rows={leaveBalanceHistory}
                    columns={leaveBalanceHistoryColumns}
                    autoHeight
                    renderTopToolbarCustomActions={() => (
                   <div className="flex items-center justify-between bg-white py-1">
                    <div className="flex items-center gap-3">
                      <div className="flex h-9 w-9 items-center justify-center rounded-xl border border-purple-100 bg-purple-50">
                        <History size={17} className="text-purple-600" />
                      </div>

                      <div>
                        <h2 className="text-md font-semibold tracking-tight text-slate-900">
                          Updated Leave History
                        </h2>

                        <div className="hidden sm:flex items-center gap-2 text-[13px] text-slate-500">
                          <span>Recent leave balance modifications</span>
                        </div>
                      </div>
                    </div>
                  </div>
                    )}
                    initialState={{
                      pagination: {
                        paginationModel: { pageSize: 10, page: 0 },
                      },
                    }}
                    pageSizeOptions={[10, 25, 50]}
                    hideFooterSelectedRowCount
                        muiTableContainerProps={{
                                    sx: {
                                        minHeight: "auto",
                                        height: 'auto',
                                        flex: 1,
                                        overflow: 'auto',
                                    },
                                }}
                  />
              </div>
            </div>
          )}
        </div>
      </div>




      <TailwindModal 
        isOpen={showImportModal} 
        toggle={() => {
          if(loading.general) return;
          setShowImportModal(false);
        }}
        maxWidth={modalStep === 0 ? "lg" : "6xl"}
      >
        <div className="p-6 flex flex-col">
          <div className="flex justify-between items-start border-b border-slate-100 pb-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-brand-50 flex items-center justify-center text-brand-600 shrink-0">
                {modalStep === 0 ? <CloudUpload size={20} /> : <ClipboardList size={20} />}
              </div>
              <div>
                <h5 className="m-0 font-bold text-slate-800 text-lg">
                  {modalStep === 0 ? 'Upload Leave Balance' : 'Import Preview (Actual vs Now)'}
                </h5>
                <p className="text-xs text-slate-500 m-0 mt-0.5 hidden sm:block">
                  {modalStep === 0 ? 'Import an Excel or CSV file to mass update balances' : 'Review changes from your file. Only matched employees are shown.'}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="text-slate-400 hover:text-slate-600 transition-colors"
              onClick={() => {
                if(loading.general) return;
                setShowImportModal(false);
              }}
            >
              <X size={20} />
            </button>
          </div>

          {modalStep === 0 ? (
            // STEP 0: UPLOAD UI
             <div className="mt-2">
                
                <div className="flex items-center gap-2 mb-4 flex-wrap">
                  <span className="text-[11px] font-semibold text-slate-400 tracking-wide uppercase w-full sm:w-auto mb-1 sm:mb-0">
                    Download Template:
                  </span>
                  {/* XLSX */}
                  <button
                    onClick={() => downloadTemplate("xlsx")}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[11px] font-medium border border-slate-200 bg-slate-50 text-slate-700 hover:bg-slate-100 hover:border-slate-300 transition-all"
                  >
                    <Download size={13} />
                    XLSX
                  </button>
                  {/* CSV */}
                  <button
                    onClick={() => downloadTemplate("csv")}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[11px] font-medium border border-slate-200 bg-slate-50 text-slate-700 hover:bg-slate-100 hover:border-slate-300 transition-all"
                  >
                    <Download size={13} />
                    CSV
                  </button>
                </div>

                {errors.import.length > 0 && (
                  <div className="mb-4 px-4 py-3 border-l-4 border-red-500 bg-red-50 text-red-700 text-sm flex flex-col gap-1 rounded-r-md">
                    <div className="flex items-start gap-2">
                      <AlertTriangle className="text-red-500 shrink-0 mt-0.5" size={16} />
                      <span className="font-semibold">Import Error</span>
                    </div>
                    <ul className="list-disc pl-8 m-0 mt-1">
                      {errors.import.map((err, i) => (
                        <li key={i}>{err}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* UPLOAD BOX */}
                <div
                  onClick={() => fileInputRef.current.click()}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop} 
                  className="border-2 border-dashed border-slate-200 rounded-2xl p-10 text-center bg-slate-50 hover:bg-slate-100 hover:border-slate-300 transition-all cursor-pointer flex flex-col items-center justify-center w-full group"
                >
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    hidden
                    onChange={handleLeaveBalanceImport}
                  />
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm border border-slate-100 mb-4 group-hover:scale-105 transition-transform">
                    <CloudUpload size={28} className="text-brand-500" />
                  </div>
                  <p className="text-sm font-medium text-slate-700 mb-1">
                    Drag and drop your file here, or <span className="text-brand-600">click to select</span>
                  </p>
                  <span className="text-[12px] text-slate-400">
                    (CSV or XLSX files only)
                  </span>
                </div>
              </div>
          ) : (
            // STEP 1: PREVIEW UI
            <div className="flex flex-col flex-1 min-h-0 mt-3">

              {errors.import.length > 0 && (
                <div className="mb-4 px-4 py-3 border-l-4 border-amber-500 bg-amber-50 text-amber-800 text-sm flex items-start gap-3 rounded-r-md">
                  <AlertTriangle className="text-amber-500 shrink-0 mt-0.5" size={18} />
                  <span><strong>Notice:</strong> {errors.import.length} issues were found in your file. Please resolve these errors to enable saving.</span>
                </div>
              )}

              <div className="max-h-[55vh] overflow-auto border border-slate-200 rounded-lg shadow-sm">
                <table className="w-full text-left border-collapse whitespace-nowrap text-xs">
                  <thead className="bg-slate-50 sticky top-0 z-10 shadow-sm">
                    <tr>
                      <th className="py-3 px-3 font-bold text-[10px] uppercase tracking-wider text-slate-500 w-[70px]">SI. No.</th>
                      <th className="py-3 px-3 font-bold text-[10px] uppercase tracking-wider text-slate-500 w-[100px]">EMP ID</th>
                      <th className="py-3 px-3 font-bold text-[10px] uppercase tracking-wider text-slate-500 w-[160px]">EMPLOYEE NAME</th>
                      <th className="py-3 px-3 font-bold text-[10px] uppercase tracking-wider text-slate-500 text-center">CURRENT (ACTUAL/NOW)</th>
                      <th className="py-3 px-3 font-bold text-[10px] uppercase tracking-wider text-slate-500 text-center">LAST YEAR (ACTUAL/NOW)</th>
                      <th className="py-3 px-3 font-bold text-[10px] uppercase tracking-wider text-slate-500 text-center">TOTAL (ACTUAL/NOW)</th>
                      <th className="py-3 px-3 font-bold text-[10px] uppercase tracking-wider text-slate-500 text-center w-[160px]">STATUS / ERROR</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100 bg-white">
                    {importPreviewData.map((item, idx) => (
                      <tr key={idx} className="hover:bg-slate-50 transition-colors">
                        <td className="py-3 px-3 align-middle text-slate-500">{idx+1}</td>
                        <td className="py-3 px-3 align-middle font-medium text-slate-700">{item.emp_id}</td>
                        <td className="py-3 px-3 align-middle font-semibold text-slate-800">{item.emp_name}</td>

                        {/* Current Year */}
                        <td className="py-3 px-3 align-middle">
                          <div className="flex items-center justify-center whitespace-nowrap">
                            <span className="font-medium text-slate-700">{formatValue(item.actual.current)}</span>
                            <span className="mx-2 text-slate-300 flex items-center"><FaArrowRightLong/></span>
                            <span className={`${
                              !item.isValid ? 'text-red-500 font-bold' : (formatValue(item.actual.current) !== formatValue(item.proposed.current) ? 'text-emerald-500 font-bold' : 'text-slate-600 font-medium')
                            }`}>
                              {formatValue(item.proposed.current)}
                            </span>
                          </div>
                        </td>

                        {/* Last Year */}
                        <td className="py-3 px-3 align-middle">
                          <div className="flex items-center justify-center whitespace-nowrap">
                            <span className="font-medium text-slate-700">{formatValue(item.actual.last)}</span>
                            <span className="mx-2 text-slate-300 flex items-center"><FaArrowRightLong/></span>
                            <span className={`${
                              !item.isValid ? 'text-red-500 font-bold' : (formatValue(item.actual.last) !== formatValue(item.proposed.last) ? 'text-emerald-500 font-bold' : 'text-slate-600 font-medium')
                            }`}>
                              {formatValue(item.proposed.last)}
                            </span>
                          </div>
                        </td>

                        {/* Total */}
                        <td className="py-3 px-3 align-middle">
                          <div className="flex items-center justify-center whitespace-nowrap">
                            <span className="font-medium text-slate-700">{formatValue(item.actual.total)}</span>
                            <span className="mx-2 text-slate-300 flex items-center"><FaArrowRightLong/></span>
                            <span className={`${
                              !item.isValid ? 'text-red-500 font-bold' : (formatValue(item.actual.total) !== formatValue(item.proposed.total) ? 'text-emerald-500 font-bold' : 'text-slate-600 font-medium')
                            }`}>
                              {formatValue(item.proposed.total)}
                            </span>
                          </div>
                        </td>

                        <td className="py-3 px-3 align-middle">
                          {item.isValid ?  (
                                item.isChanged ? (
                                  <span className="flex items-center justify-center gap-1.5 font-semibold text-emerald-600">
                                    <CheckCircle2 size={16} className="text-emerald-500" /> Ready
                                  </span>
                                ) : (
                                  <span className="flex items-center justify-center gap-1.5 font-medium text-slate-400">
                                    <FastForward size={14} /> Skipped
                                  </span>
                                )
                              ) : (
                            <span className="flex items-start justify-center gap-1.5 font-medium text-red-600">
                              <AlertCircle size={16} className="mt-0.5 shrink-0" />
                              <span className="leading-tight text-left max-w-[140px] whitespace-normal break-words">{item?.errorMessage || ""}</span>
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mt-6 pt-4 border-t border-slate-100 gap-4 sm:gap-0">
                <div className="text-sm text-slate-600 hidden sm:block">
                  <span className="font-semibold text-emerald-600">
                    {importPreviewData.filter(item => item.isValid && item.isChanged).length}
                  </span> rows affected and ready to update
                </div>
                <div className="flex gap-3 w-full sm:w-auto">
                  <button
                    type="button"
                    disabled={loading.general}
                    onClick={() => setShowImportModal(false)}
                    className="flex-1 sm:flex-none px-4 py-2 text-sm font-semibold text-slate-500 hover:bg-slate-50 rounded-lg transition-colors disabled:opacity-50"
                  >
                    Cancel
                  </button>
           <button
                    type="button"
                    onClick={confirmImportSave}
                    disabled={
                      loading.general ||
                      importPreviewData.length === 0 ||
                      errors.import.length > 0 ||
                      !hasChanges
                    }
                    className="flex-1 sm:flex-none px-5 py-2 text-sm bg-brand-600 text-white rounded-lg hover:bg-brand-700 transition-colors font-medium shadow-sm flex items-center justify-center gap-2 disabled:opacity-50 disabled:bg-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed"
                  >
                    {loading.general ? (
                      <>
                        <LoaderIcon />
                        Saving...
                      </>
                    ) : (
                      "Confirm & Save"
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </TailwindModal>



      <ActionConfirmModal 
          isOpen={confirmModal.isOpen}
          onClose={closeConfirmModal}
          onConfirm={handleConfirm}
          title={confirmModal.title}
          message={confirmModal.message}
          loading={confirmModal.loading}
          type={confirmModal.actionType === 'acceptAll' ? 'info' : 'danger'}
          confirmText={confirmModal.actionType === 'acceptAll' ? 'Accept All' : 'Confirm'}
      />

      <AcceptAllLeavesModal
          isOpen={isAcceptAllModalOpen}
          onClose={() => setIsAcceptAllModalOpen(false)}
          onConfirm={handleAcceptAllSelected}
          leaves={newLeaves}
          loading={actionLoading?.type === 'acceptAll'}
      />

      <MuiModal open={editBalanceModalOpen} onClose={() => { if(!loading.general) setEditBalanceModalOpen(false); }}>
        <Box sx={{ ...style, width: 400, bgcolor: "white", borderRadius: "12px", outline: 'none' }}>
          <div className="flex justify-between items-center mb-4">
            <h5 className="font-bold text-slate-800 m-0">Edit Leave Balance</h5>
            <button
              onClick={() => { if(!loading.general) setEditBalanceModalOpen(false); }}
              className="text-slate-400 hover:text-slate-600 transition-colors"
            >
              <FiX size={20} />
            </button>
          </div>
          


          {editBalanceData && (
            <div className="space-y-4">
              <div>
                <label className="block text-xs font-semibold text-slate-500 mb-1">Employee</label>
                <div className="text-sm font-medium text-slate-800 bg-slate-50 p-2 rounded border border-slate-200">
                  {editBalanceData.emp_name} ({editBalanceData.emp_id})
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-slate-500 mb-1">Current Year</label>
                  <TextField size="small"
                    type="number"
                    name="current_year"
                    value={editBalanceData.current_year}
                    onChange={handleEditBalanceChange}
                    className="w-full bg-white"
                    disabled={loading.general}
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-slate-500 mb-1">Last Year</label>
                  <TextField size="small"
                    type="number"
                    name="prev_year"
                    value={editBalanceData.prev_year}
                    onChange={handleEditBalanceChange}
                    className="w-full bg-white"
                    disabled={loading.general}
                  />
                </div>
                <div className="col-span-2">
                  <label className="block text-xs font-semibold text-slate-500 mb-1">Total</label>
                  <TextField size="small"
                    type="number"
                    name="total"
                    value={editBalanceData.total}
                    onChange={handleEditBalanceChange}
                    className="w-full bg-white"
                    disabled={loading.general}
                  />
                </div>
              </div>

              {errors.saveValidation.length > 0 && (
                <div className="mt-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-red-700 text-xs">
                  <ul className="m-0 pl-3 list-disc">
                    {errors.saveValidation.map((err, i) => (
                      <li key={i}>{err}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="flex justify-end gap-3 mt-6">
                <button
                  type="button"
                  onClick={() => setEditBalanceModalOpen(false)}
                  disabled={loading.general}
                  className="px-4 py-2 text-sm font-medium text-slate-600 bg-slate-100 rounded-lg hover:bg-slate-200 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleSaveEditBalance}
                  disabled={loading.general}
                  className="px-4 py-2 text-sm font-medium text-white bg-brand-600 rounded-lg hover:bg-brand-700 transition-colors flex items-center gap-2"
                >
                  {loading.general && <span className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></span>}
                  Save Changes
                </button>
              </div>
            </div>
          )}
        </Box>
      </MuiModal>
    </div>
  );
}

export default LeaveTabSA;
